import React, { useState, useEffect, useRef, useMemo, useCallback } from 'react';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import { createSeaRoute, createVessel as createVesselRecord, deleteVessel as deleteVesselRecord, listMyVessels as listMyVesselsFromApi, listVessels, saveMyVessels as saveMyVesselsToApi } from '../api/fleet';
import { lookupVesselDetails } from '../../backend/services/vesselLookup';
import { allPorts } from '../data/portDictionary';

var KLINE_PDF_VESSEL_SEEDS = [
  ['Brooklands', 'TAL', '38 A', 'BRE-DAV', 'Bremerhaven', 'Davisville', 'sea'],
  ['Nereus Highway', 'NAS', '15 A', 'SOT-CHS', 'Southampton', 'Charleston', 'sea'],
  ['Hector Highway', 'NAS', '8 A', 'SOT-CHS', 'Southampton', 'Charleston', 'sea'],
  ['Drive Green Highway', 'TAL', '100 A', 'BRE-DAV', 'Bremerhaven', 'Davisville', 'sea'],
  ['Michigan Highway', 'NAS', '176 A', 'SOT-CHS', 'Southampton', 'Charleston', 'sea'],
  ['Pontus Highway', 'NAS', '13 A', 'SOT-CHS', 'Southampton', 'Charleston', 'sea'],
  ['Hera Highway', 'NAS', '11 A', 'SOT-CHS', 'Southampton', 'Charleston', 'sea'],
  ['Donington', 'TAL', '52 A', 'BRE-DAV', 'Bremerhaven', 'Davisville', 'sea'],
  ['Nereus Highway', 'NAS', '16 A', 'SOT-CHS', 'Southampton', 'Charleston', 'sea'],
  ['Brooklands', 'TAL', '40 A', 'BRE-DAV', 'Bremerhaven', 'Davisville', 'sea'],
  ['Hector Highway', 'NAS', '9 A', 'SOT-CHS', 'Southampton', 'Charleston', 'sea'],
  ['Pontus Highway', 'NAS', '14 A', 'SOT-CHS', 'Southampton', 'Charleston', 'sea'],
  ['Drive Green Highway', 'TAL', '102 A', 'BRE-DAV', 'Bremerhaven', 'Davisville', 'sea'],
  ['Hera Highway', 'NAS', '12 A', 'SOT-CHS', 'Southampton', 'Charleston', 'sea'],
  ['Nereus Highway', 'NAS', '17 A', 'SOT-CHS', 'Southampton', 'Charleston', 'sea'],
  ['Donington', 'TAL', '54 A', 'BRE-DAV', 'Bremerhaven', 'Davisville', 'sea'],
  ['Hector Highway', 'NAS', '10 A', 'SOT-CHS', 'Southampton', 'Charleston', 'sea'],
  ['Pontus Highway', 'NAS', '15 A', 'SOT-CHS', 'Southampton', 'Charleston', 'sea'],
  ['Brooklands', 'TAL', '42 A', 'BRE-DAV', 'Bremerhaven', 'Davisville', 'sea'],
  ['Hera Highway', 'NAS', '13 A', 'SOT-CHS', 'Southampton', 'Charleston', 'sea'],
  ['Drive Green Highway', 'TAL', '104 A', 'BRE-DAV', 'Bremerhaven', 'Davisville', 'sea'],
  ['Nereus Highway', 'NAS', '18 A', 'SOT-CHS', 'Southampton', 'Charleston', 'sea'],
  ['Iguazu Highway', 'EUROZFE', '66 Z', 'DRC-KOB', 'Derince', 'Kobe', 'sea'],
  ['Amphitrite Highway', 'EUROZFE', '6 Z', 'DRC-KOB', 'Derince', 'Kobe', 'sea'],
  ['Hawaiian Highway', 'EUROZFE', '91 Z', 'DRC-KOB', 'Derince', 'Kobe', 'sea'],
  ['Niagara Highway', 'EUROZFE', '62 Z', 'DRC-KOB', 'Derince', 'Kobe', 'sea'],
  ['Thor Highway', 'EUROZFE', '16 Z', 'DRC-KOB', 'Derince', 'Kobe', 'sea'],
  ['Global Highway', 'EUROZFE', '79 Z', 'DRC-KOB', 'Derince', 'Kobe', 'sea'],
  ['Undine Highway', 'EUROZFE', '4 Z', 'DRC-KOB', 'Derince', 'Kobe', 'sea'],
  ['Grand Ruby', 'EUROZFE', '18 Z', 'DRC-KOB', 'Derince', 'Kobe', 'sea'],
  ['Euphrates Highway', 'EUROZFE', '121 Z', 'DRC-KOB', 'Derince', 'Kobe', 'sea'],
  ['Hamburg Highway', 'EUROZFE', '88 Z', 'DRC-KOB', 'Derince', 'Kobe', 'sea'],
  ['Bishu Highway', 'EUROZFE', '134 Z', 'DRC-KOB', 'Derince', 'Kobe', 'sea'],
  ['Gravity Highway', 'EUROZFE', '85 Z', 'DRC-KOB', 'Derince', 'Kobe', 'sea'],
  ['Oceanus Highway', 'EUROZFE', '10 A', 'DRC-KOB', 'Derince', 'Kobe', 'sea'],
  ['Odin Highway', 'EUROZFE', '18 Z', 'DRC-KOB', 'Derince', 'Kobe', 'sea'],
  ['Tethys Highway', 'EUROZFE', '9 Z', 'DRC-KOB', 'Derince', 'Kobe', 'sea'],
  ['Hyperion Leader', 'ASIA', '148', 'SIN-BAU', 'Singapore', 'Bauan', 'sea'],
  ['Procyon Leader', 'ASIA', '143', 'SIN-BAU', 'Singapore', 'Bauan', 'sea'],
  ['American Highway', 'ASIA', '233', 'SIN-BAU', 'Singapore', 'Bauan', 'sea'],
  ['Viking Sydney', 'ASIA', '13', 'SIN-BAU', 'Singapore', 'Bauan', 'sea'],
  ['Guangzhou Highway', 'ASIA', '198', 'SIN-BAU', 'Singapore', 'Bauan', 'sea'],
  ['Pagna', 'ASIA', '52', 'SIN-BAU', 'Singapore', 'Bauan', 'sea'],
  ['Canopus Leader', 'ASIA', '13', 'SIN-BAU', 'Singapore', 'Bauan', 'sea'],
  ['Kariyushi Leader', 'ASIA', '99', 'SIN-BAU', 'Singapore', 'Bauan', 'sea'],
  ['Grand Vision', 'ASIA', '285', 'SIN-BAU', 'Singapore', 'Bauan', 'sea'],
  ['Procyon Leader', 'ASIA', '141', 'SIN-BAU', 'Singapore', 'Bauan', 'sea'],
  ['American Highway', 'ASIA', '232', 'SIN-BAU', 'Singapore', 'Bauan', 'sea'],
  ['Guangzhou Highway', 'ASIA', '196', 'SIN-BAU', 'Singapore', 'Bauan', 'sea'],
  ['Pagna', 'ASIA', '50', 'SIN-BAU', 'Singapore', 'Bauan', 'sea'],
];

var KLINE_PDF_VESSEL_NAMES = Array.from(new Set(KLINE_PDF_VESSEL_SEEDS.map(function(item) { return item[0].toUpperCase(); })));
var KLINE_VESSELS = KLINE_PDF_VESSEL_SEEDS.map(function(item, index) {
  var progress = 18 + ((index * 13) % 70);
  return {
    id:'pdf-voyage-' + (index + 1),
    name:item[0],
    imo:'',
    type:'PCTC',
    flag:'JP',
    status:item[6],
    route:item[3],
    trade:item[1],
    speed:Number((16.1 + ((index % 7) * 0.25)).toFixed(1)),
    fuel_rate:Number((84 + ((index % 8) * 1.6)).toFixed(1)),
    cargo_util:78 + ((index * 5) % 20),
    cii_rating:index % 5 === 0 ? 'B' : 'A',
    lat:null,
    lon:null,
    eta:index % 4 === 0 ? 'In schedule' : (2 + (index % 12)) + ' days',
    next_port:item[5],
    last_port:item[4],
    lane_meters:6500 + ((index % 5) * 250),
    voyage_progress:progress,
    dwt:30000 + ((index % 5) * 1000),
    built:2014 + (index % 8),
    gt:54000 + ((index % 5) * 1200),
    propulsion:index % 6 === 0 ? 'LNG' : 'DIESEL',
    call_sign:'',
    voyage_number:item[2],
    voyage_sequence:KLINE_PDF_VESSEL_SEEDS.filter(function(seed) { return seed[0] === item[0]; }).map(function(seed) { return seed[2]; }),
  };
});

var SC = { sea:'#00d4ff', port:'#ff8c42', loading:'#ffd60a', discharge:'#00e896' };
var SL = { sea:'AT SEA', port:'IN PORT', loading:'LOADING', discharge:'DISCHARGE' };
var CB = { A:'#00c853', B:'#69f0ae', C:'#ffd60a', D:'#ff6b35', E:'#ff4560' };
var TRADE_TAGS = [
  { code:'TAL', label:'Transatlantic / US-Mex East Coast', color:'#ff4560', bg:'rgba(255,69,96,.22)' },
  { code:'NAS', label:'US East Coast', color:'#ffd60a', bg:'rgba(255,214,10,.24)' },
  { code:'EUROZFE', label:'Asia-Europe', color:'#00e896', bg:'rgba(0,232,150,.22)' },
  { code:'ASIA', label:'Intra Asia Feeder', color:'#b06aff', bg:'rgba(176,106,255,.22)' },
];
var TRADE_BY_CODE = TRADE_TAGS.reduce(function(acc, item) { acc[item.code] = item; return acc; }, {});
var LM_PER_KXX = 1.25;
var SEA_LABELS = [
  { name:'North Atlantic Ocean', lat:34, lon:-42 },
  { name:'South Atlantic Ocean', lat:-28, lon:-18 },
  { name:'North Pacific Ocean', lat:34, lon:-152 },
  { name:'South Pacific Ocean', lat:-24, lon:-132 },
  { name:'Indian Ocean', lat:-18, lon:78 },
  { name:'Mediterranean Sea', lat:36, lon:18 },
  { name:'North Sea', lat:56, lon:3 },
  { name:'Gulf of Mexico', lat:24, lon:-90 },
  { name:'Caribbean Sea', lat:15, lon:-75 },
  { name:'Arabian Sea', lat:15, lon:62 },
  { name:'South China Sea', lat:13, lon:114 },
  { name:'Red Sea', lat:20, lon:39 },
];
var WORLD_OFFSETS = [-360, 0, 360];
var PORT_COORDS = {
  BAL:{ lat:39.26, lon:-76.57 }, BALTIMORE:{ lat:39.26, lon:-76.57 },
  BAU:{ lat:13.79, lon:121.01 }, BAUAN:{ lat:13.79, lon:121.01 },
  BKI:{ lat:5.98, lon:116.07 }, 'KOTA KINABALU':{ lat:5.98, lon:116.07 },
  BRE:{ lat:53.54, lon:8.58 }, BREMERHAVEN:{ lat:53.54, lon:8.58 },
  ZEE:{ lat:51.34, lon:3.20 }, ZEEBRUGGE:{ lat:51.34, lon:3.20 },
  BRU:{ lat:31.15, lon:-81.50 }, BRUNSWICK:{ lat:31.15, lon:-81.50 },
  ALT:{ lat:22.49, lon:-97.86 }, ALTAMIRA:{ lat:22.49, lon:-97.86 },
  DAV:{ lat:41.61, lon:-71.40 }, DAVISVILLE:{ lat:41.61, lon:-71.40 },
  EMD:{ lat:53.34, lon:7.19 }, EMDEN:{ lat:53.34, lon:7.19 },
  JAX:{ lat:30.40, lon:-81.58 }, JACKSONVILLE:{ lat:30.40, lon:-81.58 },
  VER:{ lat:19.20, lon:-96.14 }, VERACRUZ:{ lat:19.20, lon:-96.14 },
  GAL:{ lat:29.31, lon:-94.79 }, GALVESTON:{ lat:29.31, lon:-94.79 },
  DRC:{ lat:40.75, lon:29.82 }, DERINCE:{ lat:40.75, lon:29.82 },
  HOU:{ lat:29.62, lon:-95.02 }, HOUSTON:{ lat:29.62, lon:-95.02 },
  HAM:{ lat:53.54, lon:9.98 }, HAMBURG:{ lat:53.54, lon:9.98 },
  HCM:{ lat:10.77, lon:106.75 }, 'HO CHI MINH':{ lat:10.77, lon:106.75 },
  HPH:{ lat:20.86, lon:106.68 }, 'HAI PHONG':{ lat:20.86, lon:106.68 },
  JKT:{ lat:-6.10, lon:106.88 }, JAKARTA:{ lat:-6.10, lon:106.88 },
  KCH:{ lat:1.56, lon:110.39 }, KUCHING:{ lat:1.56, lon:110.39 },
  KOB:{ lat:34.68, lon:135.22 }, KOBE:{ lat:34.68, lon:135.22 },
  LCB:{ lat:13.08, lon:100.88 }, 'LAEM CHABANG':{ lat:13.08, lon:100.88 },
  NEW:{ lat:40.69, lon:-74.14 }, NEWARK:{ lat:40.69, lon:-74.14 }, 'PORT NEWARK':{ lat:40.69, lon:-74.14 },
  SOT:{ lat:50.90, lon:-1.40 }, SOUTHAMPTON:{ lat:50.90, lon:-1.40 },
  YOK:{ lat:35.45, lon:139.65 }, YOKOHAMA:{ lat:35.45, lon:139.65 },
  NAG:{ lat:35.05, lon:136.88 }, NAGOYA:{ lat:35.05, lon:136.88 },
  DBN:{ lat:-29.87, lon:31.05 }, DURBAN:{ lat:-29.87, lon:31.05 },
  JEB:{ lat:25.01, lon:55.06 }, 'JEBEL ALI':{ lat:25.01, lon:55.06 },
  SIN:{ lat:1.26, lon:103.82 }, SINGAPORE:{ lat:1.26, lon:103.82 },
  GOT:{ lat:57.70, lon:11.94 }, GOTHENBURG:{ lat:57.70, lon:11.94 },
};

function fc(p) {
  if (p >= 90) return 'var(--green)';
  if (p >= 70) return 'var(--yellow)';
  return 'var(--red)';
}

function getTrade(vessel) {
  return TRADE_BY_CODE[vessel.trade] || TRADE_BY_CODE.TAL;
}

function laneMetersToKxx(laneMeters) {
  var n = Number(laneMeters || 0);
  return Math.round(n / LM_PER_KXX);
}

function kxxText(laneMeters) {
  return laneMetersToKxx(laneMeters).toLocaleString() + ' Kxx';
}

function formatVesselName(name) {
  return String(name || '').trim().replace(/\s+/g, ' ').toLowerCase().replace(/\b([a-z])/g, function(match) {
    return match.toUpperCase();
  });
}

function voyageNumber(vessel) {
  return vessel && (vessel.voyage_number || vessel.voyageNumber) ? (vessel.voyage_number || vessel.voyageNumber) : 'TBC';
}

function voyageKey(vessel) {
  return String(voyageNumber(vessel) || 'TBC').trim().toUpperCase();
}

function voyageBadge(vessel) {
  var value = voyageNumber(vessel);
  var pending = value === 'TBC';
  return React.createElement('span', { title:'Voyage number', style:{ fontSize:'9px', lineHeight:1, padding:'3px 7px', borderRadius:'4px', background:pending?'rgba(255,214,10,.12)':'rgba(0,212,255,.16)', color:pending?'var(--yellow)':'var(--accent)', border:'1px solid '+(pending?'rgba(255,214,10,.45)':'rgba(0,212,255,.55)'), fontWeight:800, letterSpacing:'.6px', whiteSpace:'nowrap', flexShrink:0, display:'inline-flex', alignItems:'center' } }, 'VOY '+value);
}

function portKey(value) {
  return String(value || '').trim().toUpperCase();
}

function portLookupKey(value) {
  return portKey(value).replace(/^PORT\s+OF\s+/, '').replace(/[^A-Z0-9 ]/g, '').replace(/\s+/g, ' ');
}

function resolveFleetPort(value, ports) {
  var key = portLookupKey(value);
  if (!key) return null;
  var direct = PORT_COORDS[key];
  var found = (ports || []).find(function(port) {
    return portLookupKey(port.code) === key || portLookupKey(port.name) === key;
  });
  var coords = direct || (found && Number.isFinite(Number(found.lat)) && Number.isFinite(Number(found.lon)) ? { lat:Number(found.lat), lon:Number(found.lon) } : null);
  if (!coords) return null;
  return {
    code:found ? found.code : key,
    name:found ? found.name : String(value),
    lat:coords.lat,
    lon:coords.lon,
  };
}

function seaRouteKey(origin, destination) {
  return [origin.lat, origin.lon, destination.lat, destination.lon].map(function(value) {
    return Number(value).toFixed(4);
  }).join(':');
}

function hasReportedMapPosition(vessel) {
  var lat = Number(vessel && vessel.lat);
  var lon = Number(vessel && vessel.lon);
  if (!Number.isFinite(lat) || !Number.isFinite(lon) || Math.abs(lat) > 90 || Math.abs(lon) > 180) return false;
  if (vessel.lat === null || vessel.lon === null || vessel.lat === '' || vessel.lon === '') return false;
  if (vessel.updated_by || vessel.aisUpdatedAt || vessel.position_source) return true;
  return !KLINE_PDF_VESSEL_NAMES.includes(formatVesselName(vessel.name).toUpperCase());
}

function pointAlongRoute(routePoints, progress) {
  if (!routePoints || routePoints.length < 2) return null;
  var pct = Math.max(0, Math.min(100, Number(progress || 50))) / 100;
  var distances = [];
  var total = 0;
  for (var i = 1; i < routePoints.length; i += 1) {
    var prev = routePoints[i - 1];
    var next = routePoints[i];
    var distance = Math.sqrt(Math.pow(next[0] - prev[0], 2) + Math.pow(next[1] - prev[1], 2));
    distances.push(distance);
    total += distance;
  }
  if (!total) return routePoints[Math.floor(routePoints.length * pct)] || routePoints[0];
  var target = total * pct;
  var travelled = 0;
  for (var j = 1; j < routePoints.length; j += 1) {
    var segment = distances[j - 1];
    if (travelled + segment >= target) {
      var ratio = segment ? (target - travelled) / segment : 0;
      var a = routePoints[j - 1];
      var b = routePoints[j];
      return [
        a[0] + ((b[0] - a[0]) * ratio),
        a[1] + ((b[1] - a[1]) * ratio),
      ];
    }
    travelled += segment;
  }
  return routePoints[routePoints.length - 1];
}

function routeBearing(from, to) {
  if (!from || !to) return 90;
  return Math.atan2(to[1] - from[1], from[0] - to[0]) * (180 / Math.PI) + 90;
}

function collectRelevantPorts(vessels, ports) {
  var byKey = {};
  (vessels || []).forEach(function(vessel) {
    var entries = [
      { name:vessel.last_port, role:'origin' },
      { name:vessel.next_port, role:'destination' },
    ];
    String(vessel.route || '').split('-').forEach(function(code) { entries.push({ name:code, role:'route' }); });
    entries.forEach(function(entry) {
      var port = resolveFleetPort(entry.name, ports);
      if (!port) return;
      var key = portLookupKey(port.code || port.name);
      if (!byKey[key]) byKey[key] = Object.assign({}, port, { vessels:[], originCount:0, destinationCount:0 });
      if (!byKey[key].vessels.includes(vessel.name)) byKey[key].vessels.push(vessel.name);
      if (entry.role === 'origin') byKey[key].originCount += 1;
      if (entry.role === 'destination') byKey[key].destinationCount += 1;
    });
  });
  return Object.keys(byKey).map(function(key) { return byKey[key]; });
}

function removeLeafletLayer(layer) {
  if (!layer) return;
  try {
    layer.remove();
  } catch {
    // Leaflet can throw if React already removed the map during a remount.
  }
}

function clearLeafletLayers(ref) {
  (ref.current || []).forEach(removeLeafletLayer);
  ref.current = [];
}

function tradeBadge(vessel) {
  var trade = getTrade(vessel);
  return React.createElement('span', { title:trade.label, style:{ fontSize:'9px', lineHeight:1, padding:'3px 7px 3px 10px', borderRadius:'4px', background:trade.bg || trade.color+'2e', color:'var(--text)', border:'1px solid '+trade.color+'dd', fontWeight:900, letterSpacing:'.8px', whiteSpace:'nowrap', flexShrink:0, display:'inline-flex', alignItems:'center', position:'relative', boxShadow:'inset 0 0 0 1px '+trade.color+'28' } },
    React.createElement('span', { style:{ position:'absolute', left:0, top:0, bottom:0, width:3, borderTopLeftRadius:3, borderBottomLeftRadius:3, background:trade.color } }),
    trade.code
  );
}

function LngBadge() {
  return React.createElement('span', { style:{ fontSize:'9px', lineHeight:1, padding:'3px 7px', borderRadius:'4px', background:'rgba(0,232,150,.15)', color:'var(--green)', border:'1px solid rgba(0,232,150,.4)', fontWeight:800, letterSpacing:'.6px', whiteSpace:'nowrap', flexShrink:0, display:'inline-flex', alignItems:'center' } }, 'LNG');
}

function vesselNominationUsers(vessel) {
  const users = Array.isArray(vessel?.my_vessel_users) ? vessel.my_vessel_users : [];
  return users
    .map(function(user) { return String(user?.name || user?.email || '').trim(); })
    .filter(Boolean);
}

function nominationBadge(vessel) {
  const users = vesselNominationUsers(vessel);
  if (!users.length) return null;
  const label = users.length > 1 ? `${users[0]} +${users.length - 1}` : users[0];
  return React.createElement('span', {
    title:'Tagged by: '+users.join(', '),
    style:{
      position:'absolute',
      top:8,
      right:8,
      maxWidth:120,
      overflow:'hidden',
      textOverflow:'ellipsis',
      whiteSpace:'nowrap',
      fontSize:'8px',
      lineHeight:1,
      padding:'4px 6px',
      borderRadius:'4px',
      background:'rgba(176,106,255,.14)',
      color:'var(--purple)',
      border:'1px solid rgba(176,106,255,.45)',
      fontWeight:800,
      letterSpacing:'.5px',
      zIndex:2,
    }
  }, label);
}

function FleetVesselCard({ vessel, isMyVessel, onOpen, onToggleMine, onDelete }) {
  var isLNG = vessel.propulsion === 'LNG' || vessel.propulsion === 'METHANOL';
  return React.createElement('div', {
    key:vessel.id,
    onClick:function(){ onOpen(vessel); },
    onMouseEnter:function(e){e.currentTarget.style.borderColor=isMyVessel?'var(--accent)':'var(--b3)';},
    onMouseLeave:function(e){e.currentTarget.style.borderColor=isMyVessel?'var(--accent)':'var(--b1)';},
    style:{ background:'var(--s1)', border:'1px solid '+(isMyVessel?'var(--accent)':'var(--b1)'), borderRadius:'var(--radius)', padding:'14px', paddingTop:vesselNominationUsers(vessel).length ? '28px' : '14px', cursor:'pointer', position:'relative' }
  },
    nominationBadge(vessel),
    React.createElement('div', { style:{ display:'flex', justifyContent:'space-between', alignItems:'flex-start', marginBottom:'8px' } },
      React.createElement('div', { style:{ flex:1, minWidth:0 } },
        React.createElement('div', { style:{ display:'flex', alignItems:'flex-start', gap:'5px', marginBottom:'2px', flexWrap:'wrap' } },
          React.createElement('div', { style:{ fontFamily:'var(--syne)', fontWeight:700, fontSize:'13px', lineHeight:1.25, whiteSpace:'normal', overflowWrap:'anywhere', flex:'1 1 150px' } }, vessel.name),
          voyageBadge(vessel),
          tradeBadge(vessel),
          isLNG && React.createElement(LngBadge)
        ),
        React.createElement('div', { style:{ fontSize:'9px', color:'var(--t2)', fontWeight:600, letterSpacing:'.4px' } }, 'IMO '+(vessel.imo || 'TBC')+' · ROUTE '+vessel.route)
      ),
      React.createElement('span', { style:{ fontSize:'8px', padding:'2px 6px', borderRadius:'20px', fontWeight:500, background:(SC[vessel.status]||'#fff')+'22', color:(SC[vessel.status]||'#fff'), flexShrink:0, marginLeft:'4px' } }, SL[vessel.status]||vessel.status)
    ),
    React.createElement('div', { style:{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:'5px', marginBottom:'7px' } },
      React.createElement('div', null, React.createElement('div',{style:{fontSize:'8px',color:'var(--t3)'}}, 'SPEED'), React.createElement('div',{style:{fontSize:'11px'}}, vessel.status==='sea'?vessel.speed+' kn':'--')),
      React.createElement('div', null, React.createElement('div',{style:{fontSize:'8px',color:'var(--t3)'}}, 'FUEL'), React.createElement('div',{style:{fontSize:'11px'}}, vessel.fuel_rate+' MT/d')),
      React.createElement('div', null, React.createElement('div',{style:{fontSize:'8px',color:'var(--t3)'}}, 'UTIL'), React.createElement('div',{style:{fontSize:'11px',color:fc(vessel.cargo_util)}}, vessel.cargo_util+'%')),
      React.createElement('div', null, React.createElement('div',{style:{fontSize:'8px',color:'var(--t3)'}}, 'VOYAGE'), React.createElement('div',{style:{fontSize:'11px',color:'var(--yellow)',fontWeight:700}}, voyageNumber(vessel))),
      React.createElement('div', null, React.createElement('div',{style:{fontSize:'8px',color:'var(--t3)'}}, 'CII'), React.createElement('span',{style:{display:'inline-block',width:'16px',height:'16px',borderRadius:'2px',background:CB[vessel.cii_rating]||'#999',color:'#000',fontSize:'9px',fontWeight:700,textAlign:'center',lineHeight:'16px'}}, vessel.cii_rating))
    ),
    React.createElement('div', { style:{ height:'3px', background:'var(--b1)', borderRadius:'2px', overflow:'hidden', marginBottom:'4px' } },
      React.createElement('div', { style:{ height:'100%', width:vessel.cargo_util+'%', background:fc(vessel.cargo_util) } })
    ),
    React.createElement('div', { style:{ fontSize:'9px', color:'var(--t3)', marginBottom:'8px' } }, 'Voy '+voyageNumber(vessel)+' / '+vessel.eta+' / '+vessel.next_port),
    React.createElement('div', { style:{ display:'flex', gap:'5px' } },
      React.createElement('button', { onClick:function(e){e.stopPropagation();onToggleMine(vessel);}, style:{ flex:1, background:isMyVessel?'rgba(255,69,96,.08)':'rgba(0,212,255,.07)', border:'1px solid '+(isMyVessel?'rgba(255,69,96,.3)':'rgba(0,212,255,.3)'), color:isMyVessel?'var(--red)':'var(--accent)', fontSize:'8px', padding:'5px', borderRadius:'4px', cursor:'pointer', fontWeight:600 } }, isMyVessel?'- Remove':'+ My Vessel'),
      React.createElement('button', { onClick:function(e){e.stopPropagation();onOpen(vessel);}, style:{ background:'rgba(0,212,255,.08)', border:'1px solid rgba(0,212,255,.3)', color:'var(--accent)', fontSize:'8px', padding:'5px 7px', borderRadius:'4px', cursor:'pointer', fontWeight:600 } }, 'Voyage Plan'),
      isDatabaseVesselId(vessel.id) && React.createElement('button', { onClick:function(e){e.stopPropagation();onDelete(vessel);}, style:{ background:'rgba(255,69,96,.08)', border:'1px solid rgba(255,69,96,.3)', color:'var(--red)', fontSize:'8px', padding:'5px 7px', borderRadius:'4px', cursor:'pointer' } }, 'Del')
    )
  );
}

function vesselIdKey(id) {
  return String(id === null || id === undefined ? '' : id);
}

function vesselSelectionKey(vessel) {
  return vesselIdKey(vessel.id) || `${formatVesselName(vessel.name)}::${voyageKey(vessel)}`;
}

function isDatabaseVesselId(id) {
  return /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(vesselIdKey(id));
}

function hasVesselId(ids, id) {
  var key = vesselIdKey(id);
  return key && (ids || []).some(function(value) { return vesselIdKey(value) === key; });
}

function hasMyVessel(myVessels, vessel) {
  var id = vesselIdKey(vessel.id);
  if (id && hasVesselId(myVessels, id)) return true;
  var key = vesselSelectionKey(vessel);
  return Boolean(key) && (myVessels || []).some(function(value) { return vesselIdKey(value) === key; });
}

function uniqueVesselIds(ids) {
  var seen = {};
  return (ids || []).filter(function(id) {
    var key = vesselIdKey(id);
    if (!key || seen[key]) return false;
    seen[key] = true;
    return true;
  });
}

function validMyVesselIds(ids, vessels) {
  var allowed = {};
  (vessels || []).forEach(function(vessel) {
    var key = vesselIdKey(vessel.id);
    if (key) allowed[key] = true;
    var selectionKey = vesselSelectionKey(vessel);
    if (selectionKey) allowed[selectionKey] = true;
  });
  return uniqueVesselIds(ids).filter(function(id) { return allowed[vesselIdKey(id)]; });
}

function persistedMyVesselIds(ids) {
  return uniqueVesselIds(ids).filter(isDatabaseVesselId);
}

function sameFleetVessel(left, right) {
  if (vesselIdKey(left.id) === vesselIdKey(right.id)) return true;
  var leftVoyage = voyageKey(left);
  var rightVoyage = voyageKey(right);
  var sameVoyage = leftVoyage === 'TBC' || rightVoyage === 'TBC' || leftVoyage === rightVoyage;
  if (left.imo && right.imo) return String(left.imo) === String(right.imo) && sameVoyage;
  var leftName = formatVesselName(left.name);
  var sameName = leftName && leftName === formatVesselName(right.name);
  if (!sameName) return false;
  return sameVoyage;
}

function sameVesselIds(left, right) {
  var a = uniqueVesselIds(left);
  var b = uniqueVesselIds(right);
  return a.length === b.length && a.every(function(id, index) { return vesselIdKey(id) === vesselIdKey(b[index]); });
}

function inferTrade(vessel) {
  var route = String(vessel.route || '').toUpperCase();
  var next = String(vessel.next_port || '').toUpperCase();
  if (route.includes('YOK') || route.includes('NAG') || route.includes('SIN') || route.includes('JEB') || next.includes('ZEEBRUGGE') || next.includes('BREMERHAVEN')) return 'EUROZFE';
  if (route.includes('JAX') || route.includes('BRU') || next.includes('JACKSONVILLE') || next.includes('BRUNSWICK')) return 'NAS';
  return 'TAL';
}

function normalizeFleetVessels(list) {
  return (list || []).map(function(v) {
    var formattedName = formatVesselName(v.name);
    return Object.assign({}, v, {
      name:formattedName || v.name,
      trade:v.trade || inferTrade(v),
      voyage_number:v.voyage_number || v.voyageNumber || 'TBC'
    });
  });
}

function mergeRemoteFleetVessel(merged, remoteVessel) {
  var normalized = normalizeFleetVessels([Object.assign({}, remoteVessel, { trade:remoteVessel.trade || inferTrade(remoteVessel) })])[0];
  var index = merged.findIndex(function(localVessel) {
    return sameFleetVessel(localVessel, normalized);
  });
  if (index >= 0) {
    merged[index] = Object.assign({}, merged[index], normalized, {
      trade:normalized.trade || merged[index].trade || inferTrade(normalized),
      voyage_sequence:merged[index].voyage_sequence || normalized.voyage_sequence,
    });
  } else {
    merged.push(normalized);
  }
  return merged;
}

// ── VESSEL SEARCH & ADD ───────────────────────────────────────────────────────
function AddVesselModal(props) {
  var onAdd = props.onAdd; var onClose = props.onClose;
  var qs = useState(''); var q = qs[0]; var setQ = qs[1];
  var ls = useState(false); var loading = ls[0]; var setLoading = ls[1];
  var rs = useState(null); var result = rs[0]; var setResult = rs[1];
  var es = useState(''); var error = es[0]; var setError = es[1];
  var ms = useState(false); var manualMode = ms[0]; var setManualMode = ms[1];

  var EMPTY = { name:'', imo:'', mmsi:'', type:'PCTC', flag:'', status:'sea', route:'', trade:'TAL', voyage_number:'', speed:16.0, fuel_rate:80.0, cargo_util:85, cii_rating:'A', lat:0, lon:0, eta:'', next_port:'', last_port:'', lane_meters:6500, voyage_progress:0, dwt:28000, built:2015, gt:50000, propulsion:'DIESEL', call_sign:'', id: Date.now() };
  var fs = useState(EMPTY); var form = fs[0]; var setForm = fs[1];

  function setF(k,v) { setForm(function(f) { var n=Object.assign({},f); n[k]=v; return n; }); }

  async function searchVessel() {
    if (!q.trim()) return;
    setLoading(true); setError(''); setResult(null);
    try {
      var parsed = await lookupVesselDetails(q);
      if (parsed.found === false) {
        setError('Vessel not found in database. Enter details manually below.');
        setManualMode(true);
        setForm(function(f) { return Object.assign({},f,{ name: q.trim() }); });
      } else {
        setResult(parsed);
        setForm(function(f) { return Object.assign({},f, parsed, { id: Date.now(), status:'sea', route:'', trade:f.trade || 'TAL', voyage_number:f.voyage_number || '', speed:16.0, fuel_rate:80.0, cargo_util:85, cii_rating:'A', lat:0, lon:0, eta:'', next_port:'', last_port:'', voyage_progress:0 }); });
      }
      setLoading(false);
      return;
    } catch(e) {
      setError((e && e.message ? e.message : 'Could not fetch vessel data') + '. Enter details manually.');
      setManualMode(true);
      setForm(function(f) { return Object.assign({},f,{ name: q.trim() }); });
    }
    setLoading(false);
  }

  var inputStyle = { width:'100%', padding:'7px 10px', fontSize:'10px' };
  var labelStyle = { fontSize:'8px', color:'var(--t3)', letterSpacing:'1.5px', textTransform:'uppercase', marginBottom:'4px', display:'block' };
  var sectionStyle = { marginBottom:'12px' };

  return React.createElement('div', { onClick:function(e){if(e.target===e.currentTarget)onClose();}, style:{ position:'fixed', inset:0, background:'rgba(0,0,0,.8)', zIndex:1000, display:'flex', alignItems:'center', justifyContent:'center', backdropFilter:'blur(8px)' } },
    React.createElement('div', { style:{ background:'var(--s1)', border:'1px solid var(--b2)', borderRadius:'12px', width:'560px', maxHeight:'85vh', display:'flex', flexDirection:'column', overflow:'hidden' } },
      React.createElement('div', { style:{ padding:'16px 20px', borderBottom:'1px solid var(--b1)', display:'flex', justifyContent:'space-between', alignItems:'center' } },
        React.createElement('div', { style:{ fontFamily:'var(--syne)', fontSize:'14px', fontWeight:700 } }, 'Add Vessel to Fleet'),
        React.createElement('button', { onClick:onClose, style:{ background:'none', border:'none', color:'var(--t2)', fontSize:'20px', cursor:'pointer' } }, 'x')
      ),
      React.createElement('div', { style:{ padding:'16px 20px', overflowY:'auto', flex:1 } },

        React.createElement('div', { style:{ marginBottom:'14px' } },
          React.createElement('label', { style:labelStyle }, 'SEARCH BY VESSEL NAME OR IMO NUMBER'),
          React.createElement('div', { style:{ display:'flex', gap:'8px' } },
            React.createElement('input', { value:q, onChange:function(e){setQ(e.target.value);}, onKeyDown:function(e){if(e.key==='Enter')searchVessel();}, placeholder:'e.g. "Poseidon Highway" or "9782947"', style:Object.assign({},inputStyle,{flex:1}) }),
            React.createElement('button', { onClick:searchVessel, disabled:loading||!q.trim(), style:{ background:loading?'var(--b2)':'var(--accent)', border:'none', color:loading?'var(--t2)':'#000', fontSize:'10px', padding:'7px 14px', borderRadius:'var(--radius-sm)', cursor:loading?'not-allowed':'pointer', fontWeight:600, whiteSpace:'nowrap' } }, loading?'Searching...':'Search')
          ),
          React.createElement('div', { style:{ display:'flex', gap:'8px', marginTop:'6px' } },
            React.createElement('button', { onClick:function(){setManualMode(!manualMode);setResult(null);setError('');}, style:{ background:'none', border:'1px solid var(--b1)', color:'var(--t2)', fontSize:'9px', padding:'3px 10px', borderRadius:'3px', cursor:'pointer' } }, manualMode?'Back to search':'Enter manually instead')
          )
        ),

        error && React.createElement('div', { style:{ background:'rgba(255,214,10,.08)', border:'1px solid rgba(255,214,10,.2)', borderRadius:'6px', padding:'10px 12px', marginBottom:'12px', fontSize:'10px', color:'var(--yellow)' } }, error),

        result && React.createElement('div', { style:{ background:'rgba(0,232,150,.06)', border:'1px solid rgba(0,232,150,.2)', borderRadius:'8px', padding:'14px', marginBottom:'14px' } },
          React.createElement('div', { style:{ fontFamily:'var(--syne)', fontSize:'13px', fontWeight:700, marginBottom:'10px', color:'var(--green)' } }, 'Vessel Found' + (result.source ? ' via ' + result.source : '')),
          React.createElement('div', { style:{ display:'grid', gridTemplateColumns:'1fr 1fr 1fr', gap:'8px' } },
            [['Name',result.name],['IMO',result.imo],['Type',result.type],['Flag',result.flag],['Built',result.built],['DWT',result.dwt?result.dwt.toLocaleString()+' MT':'—'],['GT',result.gt?result.gt.toLocaleString():'—'],['Call Sign',result.call_sign||'—'],['Propulsion',result.propulsion||'DIESEL']].map(function(item) {
              return React.createElement('div', { key:item[0], style:{ background:'var(--s2)', borderRadius:'5px', padding:'8px 10px' } },
                React.createElement('div', { style:{ fontSize:'8px', color:'var(--t3)', marginBottom:'2px' } }, item[0]),
                React.createElement('div', { style:{ fontSize:'11px', fontWeight:500 } }, item[1]||'—')
              );
            })
          )
        ),

        (result || manualMode) && React.createElement('div', null,
          React.createElement('div', { style:{ fontFamily:'var(--syne)', fontSize:'11px', fontWeight:700, color:'var(--t2)', marginBottom:'10px', letterSpacing:'1px' } }, 'OPERATIONAL DETAILS'),

          React.createElement('div', { style:{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:'10px', marginBottom:'10px' } },
            !result && React.createElement('div', { style:sectionStyle },
              React.createElement('label', { style:labelStyle }, 'VESSEL NAME *'),
              React.createElement('input', { style:inputStyle, value:form.name, onChange:function(e){setF('name',e.target.value);}, placeholder:'e.g. Global Highway' })
            ),
            !result && React.createElement('div', { style:sectionStyle },
              React.createElement('label', { style:labelStyle }, 'IMO NUMBER *'),
              React.createElement('input', { style:inputStyle, value:form.imo, onChange:function(e){setF('imo',e.target.value);}, placeholder:'7 digit number' })
            ),
            !result && React.createElement('div', { style:sectionStyle },
              React.createElement('label', { style:labelStyle }, 'MMSI'),
              React.createElement('input', { style:inputStyle, value:form.mmsi || '', onChange:function(e){setF('mmsi',e.target.value.replace(/[^0-9]/g,'').slice(0,9));}, placeholder:'9 digit MMSI' })
            ),
            !result && React.createElement('div', { style:sectionStyle },
              React.createElement('label', { style:labelStyle }, 'FLAG (2 letters)'),
              React.createElement('input', { style:inputStyle, value:form.flag, onChange:function(e){setF('flag',e.target.value.toUpperCase().slice(0,2));}, placeholder:'e.g. JP' })
            ),
            !result && React.createElement('div', { style:sectionStyle },
              React.createElement('label', { style:labelStyle }, 'TYPE'),
              React.createElement('select', { style:inputStyle, value:form.type, onChange:function(e){setF('type',e.target.value);} },
                ['PCTC','RoRo','ConRo','PCC'].map(function(t){return React.createElement('option',{key:t,value:t},t);})
              )
            ),
            !result && React.createElement('div', { style:sectionStyle },
              React.createElement('label', { style:labelStyle }, 'BUILT YEAR'),
              React.createElement('input', { type:'number', style:inputStyle, value:form.built, onChange:function(e){setF('built',parseInt(e.target.value)||2015);} })
            ),
            !result && React.createElement('div', { style:sectionStyle },
              React.createElement('label', { style:labelStyle }, 'DWT (MT)'),
              React.createElement('input', { type:'number', style:inputStyle, value:form.dwt, onChange:function(e){setF('dwt',parseInt(e.target.value)||28000);} })
            )
          ),

          React.createElement('div', { style:{ display:'grid', gridTemplateColumns:'1fr 1fr 1fr', gap:'10px', marginBottom:'10px' } },
            React.createElement('div', { style:sectionStyle },
              React.createElement('label', { style:labelStyle }, 'KXX CAPACITY'),
              React.createElement('input', { type:'number', style:inputStyle, value:laneMetersToKxx(form.lane_meters), onChange:function(e){setF('lane_meters',Math.round((parseFloat(e.target.value)||0) * LM_PER_KXX));} })
            ),
            React.createElement('div', { style:sectionStyle },
              React.createElement('label', { style:labelStyle }, 'STATUS'),
              React.createElement('select', { style:inputStyle, value:form.status, onChange:function(e){setF('status',e.target.value);} },
                ['sea','port','loading','discharge'].map(function(s){return React.createElement('option',{key:s,value:s},(SL[s]||s));})
              )
            ),
            React.createElement('div', { style:sectionStyle },
              React.createElement('label', { style:labelStyle }, 'PROPULSION'),
              React.createElement('select', { style:inputStyle, value:form.propulsion||'DIESEL', onChange:function(e){setF('propulsion',e.target.value);} },
                ['DIESEL','LNG','METHANOL','BIOFUEL','DUAL-FUEL'].map(function(p){return React.createElement('option',{key:p,value:p},p);})
              )
            )
          ),

          React.createElement('div', { style:{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:'10px', marginBottom:'10px' } },
            React.createElement('div', { style:sectionStyle },
              React.createElement('label', { style:labelStyle }, 'TRADE ROUTE (e.g. BRE-BAL)'),
              React.createElement('input', { style:inputStyle, value:form.route, onChange:function(e){setF('route',e.target.value);}, placeholder:'e.g. BRE-BAL' })
            ),
            React.createElement('div', { style:sectionStyle },
              React.createElement('label', { style:labelStyle }, 'TRADE USE TAG'),
              React.createElement('select', { style:inputStyle, value:form.trade || 'TAL', onChange:function(e){setF('trade',e.target.value);} },
                TRADE_TAGS.map(function(t){return React.createElement('option',{key:t.code,value:t.code},t.code+' - '+t.label);})
              )
            ),
            React.createElement('div', { style:sectionStyle },
              React.createElement('label', { style:labelStyle }, 'VOYAGE NUMBER'),
              React.createElement('input', { style:inputStyle, value:form.voyage_number || '', onChange:function(e){setF('voyage_number',e.target.value);}, placeholder:'e.g. 026E' })
            ),
            React.createElement('div', { style:sectionStyle },
              React.createElement('label', { style:labelStyle }, 'CII RATING'),
              React.createElement('select', { style:inputStyle, value:form.cii_rating, onChange:function(e){setF('cii_rating',e.target.value);} },
                ['A','B','C','D','E'].map(function(c){return React.createElement('option',{key:c,value:c},c);})
              )
            ),
            React.createElement('div', { style:sectionStyle },
              React.createElement('label', { style:labelStyle }, 'DESIGN SPEED (kn)'),
              React.createElement('input', { type:'number', step:0.1, style:inputStyle, value:form.speed, onChange:function(e){setF('speed',parseFloat(e.target.value)||16);} })
            ),
            React.createElement('div', { style:sectionStyle },
              React.createElement('label', { style:labelStyle }, 'FUEL RATE (MT/day)'),
              React.createElement('input', { type:'number', step:0.1, style:inputStyle, value:form.fuel_rate, onChange:function(e){setF('fuel_rate',parseFloat(e.target.value)||80);} })
            )
          )
        )
      ),
      React.createElement('div', { style:{ padding:'14px 20px', borderTop:'1px solid var(--b1)', display:'flex', justifyContent:'flex-end', gap:'8px' } },
        React.createElement('button', { onClick:onClose, style:{ background:'none', border:'1px solid var(--b1)', color:'var(--t2)', fontSize:'10px', padding:'7px 14px', borderRadius:'5px', cursor:'pointer' } }, 'Cancel'),
        (result || manualMode) && React.createElement('button', { onClick:function(){if(form.name&&form.imo){onAdd(Object.assign({},form,result||{}));onClose();}}, style:{ background:'var(--accent)', border:'none', color:'var(--on-accent)', fontSize:'10px', fontWeight:700, padding:'7px 16px', borderRadius:'5px', cursor:'pointer' } }, 'Add to Fleet')
      )
    )
  );
}

// ── VOYAGE SIMULATOR ─────────────────────────────────────────────────────────
// eslint-disable-next-line no-unused-vars
function VoyageSimulator(props) {
  var vessel = props.vessel; var onClose = props.onClose;
  var ds = useState(''); var departDate = ds[0]; var setDepartDate = ds[1];
  var ts = useState('00:00'); var departTime = ts[0]; var setDepartTime = ts[1];

  var etaDays = vessel.eta && vessel.eta.includes('day') ? parseInt(vessel.eta) : 3;
  var progress = 0;

  function getArrivalDateTime() {
    if (!departDate) return '—';
    try {
      var d = new Date(departDate + 'T' + departTime + ':00');
      d.setDate(d.getDate() + etaDays);
        return d.toLocaleString('en-GB', { day:'2-digit', month:'short', year:'numeric', hour:'2-digit', minute:'2-digit', hour12:false, hourCycle:'h23' });
    } catch(e) { return '—'; }
  }


  return React.createElement('div', { onClick:function(e){if(e.target===e.currentTarget)onClose();}, style:{ position:'fixed', inset:0, background:'rgba(0,0,0,.85)', zIndex:1000, display:'flex', alignItems:'center', justifyContent:'center', backdropFilter:'blur(10px)' } },
    React.createElement('div', { style:{ background:'var(--s1)', border:'1px solid var(--b2)', borderRadius:'14px', width:'520px', padding:'28px', boxShadow:'0 0 80px rgba(0,212,255,.12)' } },
      React.createElement('div', { style:{ display:'flex', justifyContent:'space-between', alignItems:'flex-start', marginBottom:'20px' } },
        React.createElement('div', null,
          React.createElement('div', { style:{ fontFamily:'var(--syne)', fontSize:'18px', fontWeight:800, color:'var(--accent)' } }, vessel.name),
          React.createElement('div', { style:{ fontSize:'10px', color:'var(--t2)', marginTop:'3px' } }, vessel.route+' · '+vessel.last_port+' → '+vessel.next_port),
          vessel.propulsion==='LNG' && React.createElement('span', { style:{ fontSize:'8px', padding:'1px 6px', borderRadius:'3px', background:'rgba(0,232,150,.15)', color:'var(--green)', border:'1px solid rgba(0,232,150,.4)', fontWeight:700, marginTop:'4px', display:'inline-block' } }, 'LNG POWERED')
        ),
        React.createElement('button', { onClick:onClose, style:{ background:'none', border:'none', color:'var(--t2)', fontSize:'22px', cursor:'pointer' } }, 'x')
      ),

      React.createElement('div', { style:{ background:'var(--s2)', border:'1px solid var(--b1)', borderRadius:'8px', padding:'14px', marginBottom:'20px' } },
        React.createElement('div', { style:{ fontFamily:'var(--syne)', fontSize:'10px', fontWeight:700, letterSpacing:'1.5px', color:'var(--t2)', marginBottom:'12px' } }, 'DEPARTURE'),
        React.createElement('div', { style:{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:'10px' } },
          React.createElement('div', null,
            React.createElement('div', { style:{ fontSize:'8px', color:'var(--t3)', letterSpacing:'1.5px', marginBottom:'4px' } }, 'DEPARTURE DATE'),
            React.createElement('input', { type:'date', style:{ width:'100%', padding:'7px 10px', fontSize:'11px', background:'var(--s1)', border:'1px solid var(--b1)', color:'var(--text)', borderRadius:'5px', outline:'none' }, value:departDate, onChange:function(e){setDepartDate(e.target.value);} })
          ),
          React.createElement('div', null,
            React.createElement('div', { style:{ fontSize:'8px', color:'var(--t3)', letterSpacing:'1.5px', marginBottom:'4px' } }, 'DEPARTURE TIME (UTC)'),
            React.createElement('input', { type:'time', style:{ width:'100%', padding:'7px 10px', fontSize:'11px', background:'var(--s1)', border:'1px solid var(--b1)', color:'var(--text)', borderRadius:'5px', outline:'none' }, value:departTime, onChange:function(e){setDepartTime(e.target.value);} })
          )
        ),
        departDate && React.createElement('div', { style:{ marginTop:'10px', fontSize:'10px', color:'var(--accent)' } }, 'Est. arrival: '+getArrivalDateTime()+' · '+vessel.next_port)
      ),

      React.createElement('div', { style:{ textAlign:'center', marginBottom:'20px' } },
        React.createElement('div', { style:{ fontSize:'22px', fontFamily:'var(--syne)', fontWeight:800, color:'var(--accent)', marginBottom:'6px', lineHeight:1.2 } }, vessel.last_port+' to '+vessel.next_port),
        React.createElement('div', { style:{ fontSize:'11px', color:'var(--t2)', marginBottom:'4px' } }, 'Voyage plan only. No percentage countdown is shown.'),
        React.createElement('div', { style:{ fontSize:'14px', fontFamily:'var(--syne)', color:'var(--yellow)' } }, etaDays+' days estimated sea time'),
        departDate && React.createElement('div', { style:{ fontSize:'10px', color:'var(--t3)', marginTop:'3px' } }, 'ETA: '+getArrivalDateTime()),
        progress >= 100 && React.createElement('div', { style:{ fontSize:'14px', fontFamily:'var(--syne)', color:'var(--green)' } }, 'ARRIVED — '+vessel.next_port)
      ),

      React.createElement('div', { style:{ background:'var(--s2)', borderRadius:'8px', padding:'4px', marginBottom:'20px' } },
        React.createElement('div', { style:{ height:'16px', background:'var(--b1)', borderRadius:'6px', overflow:'hidden' } },
          React.createElement('div', { style:{ height:'100%', width:'100%', background:'linear-gradient(90deg,var(--accent),#00ff9d)', borderRadius:'6px' } })
        )
      ),

      React.createElement('div', { style:{ display:'grid', gridTemplateColumns:'repeat(4,1fr)', gap:'8px', marginBottom:'20px' } },
        [['SPEED',vessel.speed+' kn'],['FUEL',vessel.fuel_rate+' MT/d'],['UTIL',vessel.cargo_util+'%'],['KXX',kxxText(vessel.lane_meters)]].map(function(item) {
          return React.createElement('div', { key:item[0], style:{ textAlign:'center', padding:'8px', background:'var(--s2)', borderRadius:'6px' } },
            React.createElement('div', { style:{ fontSize:'8px', color:'var(--t3)', letterSpacing:'1px', marginBottom:'3px' } }, item[0]),
            React.createElement('div', { style:{ fontSize:'13px', fontFamily:'var(--syne)', fontWeight:700, color:item[0]==='UTIL'?fc(vessel.cargo_util):'var(--text)' } }, item[1])
          );
        })
      ),

      React.createElement('div', { style:{ display:'flex', gap:'8px' } },
        React.createElement('button', { onClick:onClose, style:{ flex:1, background:'var(--green)', border:'none', color:'#000', fontFamily:'var(--syne)', fontSize:'12px', fontWeight:700, padding:'12px', borderRadius:'8px', cursor:'pointer', letterSpacing:'1px' } }, 'CONFIRM VOYAGE PLAN'),
        false,
        false,
        false,
        React.createElement('button', { onClick:onClose, style:{ background:'none', border:'1px solid var(--b2)', color:'var(--t2)', fontSize:'10px', padding:'12px 14px', borderRadius:'8px', cursor:'pointer' } }, 'Close')
      )
    )
  );
}

/* eslint-disable no-unused-vars, no-unreachable */
function disabledSeaChart(props) {
  var vessels = props.vessels || [];
  var myVessels = props.myVessels || [];
  var onVessel = props.onVessel;
  return React.createElement('div', { style:{ height:'100%', width:'100%', position:'relative', overflow:'hidden', background:'radial-gradient(circle at 50% 45%, rgba(0,212,255,.12), transparent 45%), linear-gradient(180deg,#06111c,#081826 55%,#050b12)' } },
    React.createElement('svg', { viewBox:'0 0 1000 520', preserveAspectRatio:'none', style:{ position:'absolute', inset:0, width:'100%', height:'100%' } },
      React.createElement('defs', null,
        React.createElement('pattern', { id:'grid', width:'50', height:'40', patternUnits:'userSpaceOnUse' },
          React.createElement('path', { d:'M 50 0 L 0 0 0 40', fill:'none', stroke:'rgba(122,155,181,.12)', strokeWidth:'1' })
        )
      ),
      React.createElement('rect', { x:0, y:0, width:1000, height:520, fill:'url(#grid)' }),
      [
        'M130,135 L205,85 L285,120 L300,205 L250,250 L170,230 L120,190 Z',
        'M250,260 L305,300 L330,380 L300,475 L250,430 L230,340 Z',
        'M430,120 L510,85 L605,120 L625,190 L565,235 L455,205 Z',
        'M545,235 L625,245 L650,315 L610,365 L535,330 Z',
        'M660,150 L750,120 L830,160 L850,230 L780,275 L690,245 Z',
        'M760,315 L835,330 L890,385 L870,450 L790,430 L740,370 Z',
        'M410,345 L455,355 L470,405 L430,430 L395,395 Z'
      ].map(function(d,i) {
        return React.createElement('path', { key:i, d:d, fill:'rgba(20,49,67,.78)', stroke:'rgba(0,212,255,.22)', strokeWidth:1.2 });
      }),
      [-120,-60,0,60,120].map(function(lon) {
        var x = ((lon + 180) / 360) * 1000;
        return React.createElement('text', { key:'lon'+lon, x:x+4, y:512, fill:'rgba(122,155,181,.45)', fontSize:'10' }, lon+'°');
      }),
      [-60,-30,0,30,60].map(function(lat) {
        var y = ((90 - lat) / 180) * 520;
        return React.createElement('text', { key:'lat'+lat, x:8, y:y-4, fill:'rgba(122,155,181,.45)', fontSize:'10' }, lat+'°');
      })
    ),
    vessels.map(function(v) {
      var p = { x:0, y:0 };
      var trade = getTrade(v);
      var isMine = hasMyVessel(myVessels, v);
      return React.createElement('button', { key:v.id, title:v.name+' · '+trade.code+' · '+(v.aisUpdatedAt ? 'AIS '+v.aisUpdatedAt : 'stored position'), onClick:function(){onVessel && onVessel(v);}, style:{ position:'absolute', left:p.x+'%', top:p.y+'%', transform:'translate(-50%,-50%)', width:isMine?22:17, height:isMine?22:17, borderRadius:'50%', background:trade.color, border:'2px solid '+(isMine?'#fff':'rgba(255,255,255,.35)'), boxShadow:'0 0 12px '+trade.color, color:'#001018', fontSize:'8px', fontWeight:900, display:'grid', placeItems:'center', cursor:'pointer', padding:0 } }, v.propulsion === 'LNG' ? 'L' : '');
    }),
    React.createElement('div', { style:{ position:'absolute', left:16, bottom:14, display:'flex', gap:'8px', flexWrap:'wrap' } },
      TRADE_TAGS.map(function(t) {
        return React.createElement('span', { key:t.code, style:{ fontSize:'9px', color:t.color, border:'1px solid '+t.color+'55', background:t.color+'12', borderRadius:'4px', padding:'4px 7px', fontWeight:700 } }, t.code+' - '+t.label);
      })
    )
  );
}
/* eslint-enable no-unused-vars, no-unreachable */

/* eslint-disable no-unused-vars */
function projectPoint(lat, lon) {
  return {
    x: ((Number(lon) + 180) / 360) * 1000,
    y: ((90 - Number(lat)) / 180) * 520,
  };
}

function GradientWorldMap(props) {
  var vessels = props.vessels || [];
  var myVessels = props.myVessels || [];
  var onVessel = props.onVessel;
  var validPositions = vessels.filter(function(v) {
    var lat = Number(v.lat);
    var lon = Number(v.lon);
    return Number.isFinite(lat) && Number.isFinite(lon) && Math.abs(lat) <= 90 && Math.abs(lon) <= 180;
  });
  var landPaths = [
    'M95,150 L125,120 L178,94 L245,82 L310,102 L335,140 L322,188 L274,218 L235,252 L188,258 L146,238 L112,202 Z',
    'M260,260 L302,298 L323,356 L308,425 L278,482 L240,430 L220,360 L230,306 Z',
    'M360,70 L420,42 L465,68 L450,120 L392,128 Z',
    'M455,132 L505,108 L575,112 L635,138 L625,188 L552,205 L495,190 Z',
    'M512,202 L575,218 L604,284 L586,358 L540,432 L494,375 L474,292 Z',
    'M594,132 L675,90 L785,98 L905,142 L940,205 L890,258 L782,260 L704,226 L634,198 Z',
    'M700,245 L765,264 L812,322 L846,384 L816,448 L748,420 L710,350 Z',
    'M815,338 L880,348 L922,388 L902,438 L832,430 Z',
    'M700,54 L760,58 L795,88 L760,112 L700,100 Z',
    'M884,256 L934,280 L956,330 L928,360 L888,320 Z',
    'M428,218 L470,224 L455,252 L418,248 Z',
    'M790,258 L840,270 L822,304 L770,294 Z',
  ];
  var seaLabels = [
    { name:'NORTH ATLANTIC', x:375, y:210 },
    { name:'SOUTH ATLANTIC', x:415, y:390 },
    { name:'PACIFIC OCEAN', x:120, y:315 },
    { name:'INDIAN OCEAN', x:665, y:365 },
    { name:'ARABIAN SEA', x:640, y:285 },
    { name:'NORTH SEA', x:505, y:150 },
  ];

  return React.createElement('div', { style:{ height:'100%', minHeight:'520px', position:'relative', overflow:'hidden', background:'#03070d' } },
    React.createElement('svg', { viewBox:'0 0 1000 520', preserveAspectRatio:'xMidYMid meet', style:{ position:'absolute', inset:0, width:'100%', height:'100%' } },
      React.createElement('defs', null,
        React.createElement('radialGradient', { id:'oceanGlow', cx:'50%', cy:'48%', r:'62%' },
          React.createElement('stop', { offset:'0%', stopColor:'#0b2740', stopOpacity:.92 }),
          React.createElement('stop', { offset:'48%', stopColor:'#061421', stopOpacity:.96 }),
          React.createElement('stop', { offset:'100%', stopColor:'#02050a', stopOpacity:1 })
        ),
        React.createElement('linearGradient', { id:'landCyan', x1:'0%', y1:'0%', x2:'100%', y2:'0%' },
          React.createElement('stop', { offset:'0%', stopColor:'#00d4ff' }),
          React.createElement('stop', { offset:'48%', stopColor:'#0aa8bd' }),
          React.createElement('stop', { offset:'100%', stopColor:'#00e6d2' })
        ),
        React.createElement('filter', { id:'landGlow', x:'-20%', y:'-20%', width:'140%', height:'140%' },
          React.createElement('feGaussianBlur', { stdDeviation:'3.5', result:'blur' }),
          React.createElement('feColorMatrix', { in:'blur', type:'matrix', values:'0 0 0 0 0  0 0 0 0 0.72  0 0 0 0 0.9  0 0 0 .42 0', result:'glow' }),
          React.createElement('feMerge', null,
            React.createElement('feMergeNode', { in:'glow' }),
            React.createElement('feMergeNode', { in:'SourceGraphic' })
          )
        ),
        React.createElement('pattern', { id:'chartGrid', width:'60', height:'52', patternUnits:'userSpaceOnUse' },
          React.createElement('path', { d:'M60 0 L0 0 0 52', fill:'none', stroke:'rgba(0,212,255,.08)', strokeWidth:'1' })
        )
      ),
      React.createElement('rect', { width:1000, height:520, fill:'url(#oceanGlow)' }),
      React.createElement('rect', { width:1000, height:520, fill:'url(#chartGrid)', opacity:.55 }),
      React.createElement('ellipse', { cx:500, cy:270, rx:390, ry:210, fill:'none', stroke:'rgba(0,212,255,.08)', strokeWidth:1.2 }),
      landPaths.map(function(d, i) {
        return React.createElement('path', { key:i, d:d, fill:'url(#landCyan)', opacity:.78, filter:'url(#landGlow)' });
      }),
      seaLabels.map(function(label) {
        return React.createElement('text', { key:label.name, x:label.x, y:label.y, textAnchor:'middle', fill:'rgba(180,225,245,.34)', fontSize:'12', fontFamily:'Georgia, serif', fontStyle:'italic', letterSpacing:'2px' }, label.name);
      }),
      validPositions.map(function(v) {
        var p = projectPoint(v.lat, v.lon);
        var trade = getTrade(v);
        var isMine = hasMyVessel(myVessels, v);
        return React.createElement('g', { key:v.id, onClick:function(){ if (onVessel) onVessel(v); }, style:{ cursor:'pointer' } },
          React.createElement('circle', { cx:p.x, cy:p.y, r:isMine?8:6, fill:'none', stroke:trade.color, strokeOpacity:.24, strokeWidth:8 }),
          React.createElement('circle', { cx:p.x, cy:p.y, r:isMine?5:3.5, fill:trade.color, stroke:isMine?'#fff':'rgba(255,255,255,.68)', strokeWidth:1.1 }),
          React.createElement('title', null, v.name+' - '+trade.code+' - '+Number(v.lat).toFixed(3)+', '+Number(v.lon).toFixed(3))
        );
      })
    ),
    React.createElement('div', { style:{ position:'absolute', top:14, left:14, background:'rgba(3,7,13,.76)', border:'1px solid rgba(0,212,255,.22)', borderRadius:'6px', padding:'8px 10px', pointerEvents:'none', boxShadow:'0 0 24px rgba(0,212,255,.08)' } },
      React.createElement('div', { style:{ fontFamily:'var(--syne)', fontSize:'11px', fontWeight:700, color:'var(--text)' } }, 'Fleet World Map'),
      React.createElement('div', { style:{ fontSize:'9px', color:'var(--t2)', marginTop:'2px' } }, validPositions.length+' noon report positions')
    ),
    React.createElement('div', { style:{ position:'absolute', left:14, bottom:14, display:'flex', gap:'7px', flexWrap:'wrap', pointerEvents:'none' } },
      TRADE_TAGS.map(function(t) {
        return React.createElement('span', { key:t.code, style:{ fontSize:'9px', color:t.color, border:'1px solid '+t.color+'55', background:'rgba(3,7,13,.78)', borderRadius:'4px', padding:'4px 7px', fontWeight:700 } }, t.code);
      })
    )
  );
}
/* eslint-enable no-unused-vars */

function LeafletWorldMap(props) {
  var vessels = props.vessels;
  var myVessels = props.myVessels;
  var onVessel = props.onVessel;
  var containerRef = useRef(null);
  var mapRef = useRef(null);
  var landRef = useRef(null);
  var gridRef = useRef([]);
  var markersRef = useRef([]);
  var portMarkersRef = useRef([]);
  var routeLinesRef = useRef([]);
  var routeArrowsRef = useRef([]);
  var seaLabelsRef = useRef([]);
  var srs = useState({}); var seaRoutes = srs[0]; var setSeaRoutes = srs[1];
  var knownPorts = useMemo(function() { return allPorts(); }, []);
  var relevantPorts = useMemo(function() { return collectRelevantPorts(vessels || [], knownPorts); }, [vessels, knownPorts]);
  var routeCapableVessels = useMemo(function() { return (vessels || []).filter(function(vessel) {
    return resolveFleetPort(vessel.last_port, knownPorts) && resolveFleetPort(vessel.next_port, knownPorts);
  }); }, [vessels, knownPorts]);
  var mapPositions = useMemo(function() {
    return (vessels || []).map(function(vessel) {
      var lastPort = resolveFleetPort(vessel.last_port, knownPorts);
      var nextPort = resolveFleetPort(vessel.next_port, knownPorts);
      var reported = hasReportedMapPosition(vessel);
      if (reported) {
        return Object.assign({}, vessel, {
          mapLat:Number(vessel.lat),
          mapLon:Number(vessel.lon),
          mapPositionType:vessel.aisUpdatedAt ? 'AIS' : (vessel.updated_by ? 'Noon report' : 'Reported'),
        });
      }
      if (!lastPort || !nextPort) return null;
      var routePoints = seaRoutes[seaRouteKey(lastPort, nextPort)] || [];
      var point = pointAlongRoute(routePoints, vessel.voyage_progress);
      if (!point) return null;
      return Object.assign({}, vessel, {
        mapLat:point[0],
        mapLon:point[1],
        mapPositionType:'Estimated from schedule',
      });
    }).filter(Boolean);
  }, [vessels, knownPorts, seaRoutes]);
  var mapSummary = useMemo(function() {
    var estimated = mapPositions.filter(function(v) { return v.mapPositionType === 'Estimated from schedule'; }).length;
    var live = mapPositions.length - estimated;
    var my = mapPositions.filter(function(v) { return hasMyVessel(myVessels, v); }).length;
    return {
      total:mapPositions.length,
      estimated:estimated,
      live:live,
      my:my,
      missing:Math.max(0, (vessels || []).length - mapPositions.length),
    };
  }, [mapPositions, myVessels, vessels]);

  useEffect(function() {
    var cancelled = false;
    var pending = {};
    routeCapableVessels.forEach(function(vessel) {
      var lastPort = resolveFleetPort(vessel.last_port, knownPorts);
      var nextPort = resolveFleetPort(vessel.next_port, knownPorts);
      if (!lastPort || !nextPort) return;
      pending[seaRouteKey(lastPort, nextPort)] = [lastPort, nextPort];
    });
    Promise.all(Object.keys(pending).map(function(key) {
      var ports = pending[key];
      return createSeaRoute([ports[0].lon, ports[0].lat], [ports[1].lon, ports[1].lat])
        .then(function(route) { return [key, route.coordinates || []]; })
        .catch(function() { return [key, []]; });
    })).then(function(routes) {
      if (cancelled) return;
      var next = {};
      routes.forEach(function(item) {
        next[item[0]] = item[1]
          .filter(function(point) { return Array.isArray(point) && point.length >= 2; })
          .map(function(point) { return [Number(point[1]), Number(point[0])]; });
      });
      setSeaRoutes(next);
    });
    return function() { cancelled = true; };
  }, [routeCapableVessels, knownPorts, setSeaRoutes]);

  useEffect(function() {
    if (!containerRef.current || mapRef.current) return;
    var container = containerRef.current;
    var cancelled = false;
    var abortController = new AbortController();
    var resizeTimer = null;
    var map = null;
    if (container._leaflet_id) delete container._leaflet_id;
    try {
      map = L.map(container, {
        center:[20, 5],
        zoom:2,
        minZoom:2,
        maxZoom:6,
        worldCopyJump:true,
        zoomControl:true,
        attributionControl:false,
      });
      mapRef.current = map;
    } catch (error) {
      console.warn('Fleet map initialization failed.', error.message);
      mapRef.current = null;
      return undefined;
    }
    L.control.attribution({ prefix:false }).addAttribution('Natural Earth / OpenStreetMap').addTo(map);
    WORLD_OFFSETS.forEach(function(offset) {
      [-60,-30,0,30,60].forEach(function(lat) {
        gridRef.current.push(L.polyline([[lat, -180 + offset], [lat, 180 + offset]], { color:'rgba(0,212,255,.12)', weight:1, interactive:false, className:'fleet-grid-line' }).addTo(map));
      });
      [-120,-60,0,60,120].forEach(function(lon) {
        gridRef.current.push(L.polyline([[-70, lon + offset], [80, lon + offset]], { color:'rgba(0,212,255,.10)', weight:1, interactive:false, className:'fleet-grid-line' }).addTo(map));
      });
    });
    fetch('/data/countries.geojson', { signal:abortController.signal }).then(function(response) { return response.json(); }).then(function(geojson) {
      if (cancelled || mapRef.current !== map) return;
      var landLayer = L.layerGroup();
      WORLD_OFFSETS.forEach(function(offset) {
        L.geoJSON(geojson, {
          coordsToLatLng:function(coords) {
            return new L.LatLng(coords[1], coords[0] + offset);
          },
          style:function() {
            return {
              fillColor:'#00d4ff',
              fillOpacity:.68,
              color:'rgba(0,232,210,.58)',
              weight:.45,
              opacity:.85,
              interactive:false,
              className:'fleet-land-shape',
            };
          },
        }).addTo(landLayer);
      });
      if (landRef.current) removeLeafletLayer(landRef.current);
      landRef.current = landLayer;
      landLayer.addTo(map);
    }).catch(function(error) {
      if (error && error.name !== 'AbortError') console.warn('Fleet map land layer failed.', error.message);
    });
    resizeTimer = setTimeout(function(){ if (!cancelled && mapRef.current === map) map.invalidateSize(true); }, 120);
    return function() {
      cancelled = true;
      abortController.abort();
      if (resizeTimer) clearTimeout(resizeTimer);
      clearLeafletLayers(markersRef);
      clearLeafletLayers(portMarkersRef);
      clearLeafletLayers(routeLinesRef);
      clearLeafletLayers(routeArrowsRef);
      clearLeafletLayers(seaLabelsRef);
      clearLeafletLayers(gridRef);
      if (landRef.current) {
        removeLeafletLayer(landRef.current);
        landRef.current = null;
      }
      if (mapRef.current === map) {
        try {
          map.remove();
        } catch {
          // Ignore Leaflet cleanup races during React remounts.
        }
        mapRef.current = null;
      }
      if (container._leaflet_id) delete container._leaflet_id;
    };
  }, []);

  useEffect(function() {
    var map = mapRef.current;
    if (!map) return;
    clearLeafletLayers(markersRef);
    clearLeafletLayers(portMarkersRef);
    clearLeafletLayers(routeLinesRef);
    clearLeafletLayers(routeArrowsRef);
    clearLeafletLayers(seaLabelsRef);
    WORLD_OFFSETS.forEach(function(offset) {
      SEA_LABELS.forEach(function(label) {
        var seaIcon = L.divIcon({
          html:'<div class="fleet-sea-label">'+label.name+'</div>',
          className:'fleet-sea-label-icon',
          iconSize:[160, 18],
          iconAnchor:[80, 9],
        });
        seaLabelsRef.current.push(L.marker([label.lat, label.lon + offset], { icon:seaIcon, interactive:false, keyboard:false }).addTo(map));
      });
    });
    mapPositions.forEach(function(v) {
      var lat = Number(v.mapLat);
      var lon = Number(v.mapLon);
      var isMine = hasMyVessel(myVessels, v);
      var lastPort = resolveFleetPort(v.last_port, knownPorts);
      var nextPort = resolveFleetPort(v.next_port, knownPorts);
      WORLD_OFFSETS.forEach(function(offset) {
        var routePoints = lastPort && nextPort
          ? (seaRoutes[seaRouteKey(lastPort, nextPort)] || []).map(function(point) { return [point[0], point[1] + offset]; })
          : [];
        routePoints = routePoints.filter(function(point) {
          return Number.isFinite(point[0]) && Number.isFinite(point[1]);
        });
        if (routePoints.length > 1) {
          routeLinesRef.current.push(L.polyline(routePoints, {
            color:'rgba(0,212,255,.42)',
            weight:1.8,
            opacity:.86,
            dashArray:'7 8',
            lineCap:'round',
            lineJoin:'round',
            interactive:false,
            className:'fleet-route-line',
          }).addTo(map));
          [34, 62].forEach(function(progress) {
            var arrowPoint = pointAlongRoute(routePoints, progress);
            if (!arrowPoint) return;
            var arrowNext = pointAlongRoute(routePoints, Math.min(98, progress + 2)) || arrowPoint;
            var angle = routeBearing(arrowPoint, arrowNext);
            var arrowIcon = L.divIcon({
              html:'<div class="fleet-route-arrow" style="transform:rotate('+angle+'deg)">&#9658;</div>',
              className:'fleet-route-arrow-icon',
              iconSize:[18,18],
              iconAnchor:[9,9],
            });
            routeArrowsRef.current.push(L.marker([arrowPoint[0], arrowPoint[1]], { icon:arrowIcon, interactive:false, keyboard:false }).addTo(map));
          });
        }
        var markerSize = isMine ? 14 : 11;
        var heading = Number.isFinite(Number(v.heading)) ? Number(v.heading) : 90;
        var markerColor = '#ff334f';
        var markerGlow = 'rgba(255,51,79,.75)';
        var html = '<div class="fleet-vessel-marker '+(v.mapPositionType === 'Estimated from schedule' ? 'is-estimated' : 'is-reported')+'" style="width:0;height:0;border-left:'+(markerSize/2)+'px solid transparent;border-right:'+(markerSize/2)+'px solid transparent;border-bottom:'+markerSize+'px solid '+markerColor+';filter:drop-shadow(0 0 5px '+markerGlow+');transform:rotate('+heading+'deg);transform-origin:50% 65%;"></div>';
        var icon = L.divIcon({ html:html, className:'fleet-vessel-triangle', iconSize:[markerSize,markerSize], iconAnchor:[markerSize/2,markerSize/2] });
        var marker = L.marker([lat, lon + offset], { icon:icon }).addTo(map);
        marker.bindTooltip(v.name, {
          direction:'top',
          offset:[0, -8],
          opacity:.96,
          sticky:true,
        });
        marker.bindPopup('<div class="fleet-map-popup"><b>'+v.name+'</b><br/>Voyage '+voyageNumber(v)+' / '+(v.trade || '-')+'<br/>Lat '+lat.toFixed(3)+' / Lon '+lon.toFixed(3)+'<br/>Speed '+(v.status==='sea'?v.speed+' kn':'-')+'<br/>Position: '+v.mapPositionType+'</div>');
        marker.on('click', function(){ if (onVessel) onVessel(v); });
        markersRef.current.push(marker);
      });
    });
    relevantPorts.forEach(function(port) {
      WORLD_OFFSETS.forEach(function(offset) {
        var portRole = port.destinationCount > port.originCount ? 'is-destination' : (port.originCount ? 'is-origin' : 'is-route');
        var icon = L.divIcon({
          html:'<div class="fleet-port-dot '+portRole+'"></div>',
          className:'fleet-port-marker',
          iconSize:[12,12],
          iconAnchor:[6,6],
        });
        var marker = L.marker([port.lat, port.lon + offset], { icon:icon }).addTo(map);
        marker.bindPopup('<div class="fleet-map-popup"><b>'+port.name+'</b><br/>Code '+(port.code || '-')+'<br/>Relevant vessels: '+port.vessels.length+'</div>');
        portMarkersRef.current.push(marker);
      });
    });
    map.setView([20, 5], 2);
    var timer = setTimeout(function(){ if (mapRef.current === map) map.invalidateSize(true); }, 80);
    return function() { clearTimeout(timer); };
  }, [mapPositions, myVessels, onVessel, knownPorts, relevantPorts, seaRoutes]);

  return React.createElement('div', { className:'fleet-nautical-map', style:{ height:'100%', minHeight:'520px', width:'100%', position:'relative', background:'var(--fleet-map-bg,#02050a)', overflow:'hidden' } },
    React.createElement('style', null, '.fleet-nautical-map{--fleet-map-bg:#02050a;--fleet-map-water:radial-gradient(circle at 50% 48%,#0b2740 0%,#061421 42%,#02050a 100%);--fleet-map-overlay:radial-gradient(circle at 50% 48%,rgba(0,212,255,.14),transparent 44%),linear-gradient(180deg,#03070d,#061421 52%,#02050a);--fleet-map-grid:linear-gradient(rgba(0,212,255,.12) 1px, transparent 1px), linear-gradient(90deg, rgba(0,212,255,.12) 1px, transparent 1px);--fleet-map-panel:rgba(3,7,13,.78);--fleet-map-panel-border:rgba(0,212,255,.22);--fleet-map-legend:rgba(7,19,31,.82);--fleet-popup-bg:#06111c;--fleet-popup-text:#e8f4ff}.fleet-nautical-map .leaflet-container{background:var(--fleet-map-water)}.fleet-nautical-map .leaflet-overlay-pane svg{filter:drop-shadow(0 0 8px rgba(0,212,255,.22))}.fleet-nautical-map .leaflet-marker-pane{z-index:650}.fleet-nautical-map .leaflet-control-attribution{background:rgba(3,7,13,.74);color:#7a9bb5}.fleet-nautical-map .leaflet-control-zoom a{background:#06111c;color:#00d4ff;border-color:rgba(0,212,255,.22)}.fleet-nautical-map .leaflet-popup-content-wrapper,.fleet-nautical-map .leaflet-popup-tip{background:var(--fleet-popup-bg);color:var(--fleet-popup-text);border:1px solid rgba(0,212,255,.2)}.fleet-nautical-map .leaflet-tooltip{background:rgba(3,7,13,.94);border:1px solid rgba(0,212,255,.42);border-radius:4px;color:#e8f4ff;font-size:10px;font-weight:700;padding:4px 7px;box-shadow:0 0 16px rgba(0,212,255,.16)}.fleet-nautical-map .leaflet-tooltip-top:before{border-top-color:rgba(0,212,255,.42)}.fleet-map-popup{min-width:180px;background:var(--fleet-popup-bg);color:var(--fleet-popup-text);font-family:Arial,sans-serif}.fleet-port-dot{width:12px;height:12px;border-radius:50%;border:1px solid rgba(0,212,255,.85);background:rgba(0,212,255,.14);box-shadow:0 0 10px rgba(0,212,255,.22);position:relative}.fleet-port-dot:after{content:"";position:absolute;left:4px;top:4px;width:4px;height:4px;border-radius:50%;background:#00d4ff}.fleet-sea-label{font-family:Georgia,serif;font-size:12px;font-style:italic;letter-spacing:1.6px;text-transform:uppercase;color:rgba(180,225,245,.38);text-shadow:0 1px 2px rgba(0,0,0,.95),0 0 12px rgba(0,212,255,.18);text-align:center;white-space:nowrap;pointer-events:none}.fleet-sea-label-icon{background:transparent;border:none}:root[data-theme="light"] .fleet-nautical-map{--fleet-map-bg:#D7EAF5;--fleet-map-water:linear-gradient(180deg,#D7EAF5 0%,#BFD9E8 54%,#AFCFDF 100%);--fleet-map-overlay:linear-gradient(180deg,rgba(255,255,255,.28),rgba(198,219,232,.16));--fleet-map-grid:linear-gradient(rgba(18,58,114,.10) 1px, transparent 1px), linear-gradient(90deg, rgba(18,58,114,.10) 1px, transparent 1px);--fleet-map-panel:rgba(255,255,255,.88);--fleet-map-panel-border:rgba(18,58,114,.18);--fleet-map-legend:rgba(255,255,255,.86);--fleet-popup-bg:#fff;--fleet-popup-text:#1b2a41}:root[data-theme="light"] .fleet-nautical-map .fleet-land-shape{fill:#F7F8FA!important;fill-opacity:1!important;stroke:#AEBCCA!important;stroke-width:.55!important}:root[data-theme="light"] .fleet-nautical-map .fleet-grid-line{stroke:rgba(18,58,114,.12)!important}:root[data-theme="light"] .fleet-nautical-map .fleet-route-line{stroke:rgba(18,58,114,.48)!important;filter:none!important}:root[data-theme="light"] .fleet-nautical-map .fleet-port-dot{border-color:rgba(18,58,114,.72);background:rgba(18,58,114,.08);box-shadow:0 2px 8px rgba(18,58,114,.12)}:root[data-theme="light"] .fleet-nautical-map .fleet-port-dot:after{background:#123a72}:root[data-theme="light"] .fleet-nautical-map .leaflet-container{background:var(--fleet-map-water)}:root[data-theme="light"] .fleet-nautical-map .leaflet-overlay-pane svg{filter:none}:root[data-theme="light"] .fleet-nautical-map .leaflet-control-attribution{background:rgba(255,255,255,.78);color:#66758c}:root[data-theme="light"] .fleet-nautical-map .leaflet-control-zoom a{background:#fff;color:#123a72;border-color:#d6e1ea}:root[data-theme="light"] .fleet-nautical-map .leaflet-popup-content-wrapper,:root[data-theme="light"] .fleet-nautical-map .leaflet-popup-tip{background:#fff;color:#1b2a41;border-color:#dce5ef}:root[data-theme="light"] .fleet-nautical-map .leaflet-tooltip{background:rgba(255,255,255,.96);border-color:rgba(18,58,114,.22);color:#1b2a41;box-shadow:0 8px 22px rgba(18,58,114,.10)}:root[data-theme="light"] .fleet-sea-label{color:rgba(18,58,114,.34);text-shadow:0 1px 0 rgba(255,255,255,.85)}'),
    React.createElement('style', null, '.fleet-route-arrow,.fleet-map-intel{display:none}:root[data-theme="light"] .fleet-nautical-map{--fleet-map-bg:#D7EAF5;--fleet-map-water:linear-gradient(180deg,#D7EAF5 0%,#BFD9E8 54%,#AFCFDF 100%);--fleet-map-sheen:linear-gradient(90deg,rgba(255,255,255,.18),transparent 42%,rgba(18,58,114,.04));--fleet-map-inset:inset 0 0 0 1px rgba(18,58,114,.08)}:root[data-theme="light"] .fleet-route-arrow{display:grid;place-items:center;width:18px;height:18px;color:#123a72;font-size:12px;font-weight:900;line-height:1;opacity:.62;text-shadow:0 1px 0 rgba(255,255,255,.8)}:root[data-theme="light"] .fleet-port-dot.is-origin{background:#fff;border-color:#123a72}:root[data-theme="light"] .fleet-port-dot.is-origin:after{background:#fff;border:1px solid #123a72;left:3px;top:3px;width:4px;height:4px}:root[data-theme="light"] .fleet-port-dot.is-destination{background:#123a72;border-color:#123a72}:root[data-theme="light"] .fleet-port-dot.is-destination:after{background:#fff}:root[data-theme="light"] .fleet-map-intel{display:block}'),
    React.createElement('div', { style:{ position:'absolute', inset:0, zIndex:0, background:'var(--fleet-map-overlay)' } },
      React.createElement('div', { style:{ position:'absolute', inset:0, opacity:.18, backgroundImage:'var(--fleet-map-grid)', backgroundSize:'72px 72px' } })
    ),
    React.createElement('div', { ref:containerRef, style:{ height:'100%', width:'100%', position:'relative', zIndex:1 } }),
    React.createElement('div', { style:{ position:'absolute', inset:0, zIndex:2, pointerEvents:'none', background:'var(--fleet-map-sheen,linear-gradient(90deg,rgba(0,212,255,.08),transparent 36%,rgba(0,232,210,.08)))', mixBlendMode:'screen' } }),
    React.createElement('div', { style:{ position:'absolute', inset:0, zIndex:3, pointerEvents:'none', boxShadow:'var(--fleet-map-inset,inset 0 0 58px rgba(0,0,0,.52))' } }),
    React.createElement('div', { style:{ position:'absolute', top:14, left:14, zIndex:500, background:'var(--fleet-map-panel)', border:'1px solid var(--fleet-map-panel-border)', borderRadius:'6px', padding:'8px 10px', pointerEvents:'none', boxShadow:'0 0 24px rgba(0,212,255,.08)' } },
      React.createElement('div', { style:{ fontFamily:'var(--syne)', fontSize:'11px', fontWeight:700, color:'var(--text)' } }, 'Nautical Fleet Chart'),
      React.createElement('div', { style:{ fontSize:'9px', color:'var(--t2)', marginTop:'2px' } }, mapPositions.length+' vessel positions / '+relevantPorts.length+' relevant ports')
    ),
    React.createElement('div', { className:'fleet-map-intel', style:{ position:'absolute', top:14, right:14, zIndex:500, width:168, background:'var(--fleet-map-panel)', border:'1px solid var(--fleet-map-panel-border)', borderRadius:6, padding:'9px 10px', boxShadow:'0 10px 24px rgba(18,58,114,.10)', pointerEvents:'none' } },
      React.createElement('div', { style:{ fontFamily:'var(--syne)', fontSize:10, fontWeight:800, letterSpacing:1.1, color:'#123a72', marginBottom:7 } }, 'MAP INTELLIGENCE'),
      [
        ['Plotted', mapSummary.total],
        ['Live / Reported', mapSummary.live],
        ['Estimated', mapSummary.estimated],
        ['My Vessels', mapSummary.my],
        ['No Position', mapSummary.missing],
      ].map(function(item) {
        return React.createElement('div', { key:item[0], style:{ display:'flex', justifyContent:'space-between', gap:8, fontSize:10, color:'var(--t2)', padding:'3px 0', borderTop:item[0] === 'Plotted' ? '0' : '1px solid rgba(18,58,114,.08)' } },
          React.createElement('span', null, item[0]),
          React.createElement('strong', { style:{ color:item[0] === 'Estimated' ? '#123a72' : 'var(--text)', fontWeight:800 } }, item[1])
        );
      })
    ),
    !mapPositions.length && React.createElement('div', { style:{ position:'absolute', inset:0, zIndex:450, display:'grid', placeItems:'center', pointerEvents:'none' } },
      React.createElement('div', { style:{ background:'var(--fleet-map-panel)', border:'1px solid var(--fleet-map-panel-border)', borderRadius:'8px', padding:'14px 18px', textAlign:'center' } },
        React.createElement('div', { style:{ fontFamily:'var(--syne)', fontSize:'13px', fontWeight:700, color:'var(--accent)', marginBottom:'4px' } }, 'No plotted vessel positions'),
        React.createElement('div', { style:{ fontSize:'10px', color:'var(--t2)' } }, 'Use noon/AIS positions or schedule routes to plot vessels.')
      )
    ),
    React.createElement('div', { style:{ position:'absolute', left:14, bottom:14, zIndex:500, display:'flex', gap:'7px', flexWrap:'wrap', pointerEvents:'none' } },
      TRADE_TAGS.map(function(t) {
        return React.createElement('span', { key:t.code, style:{ fontSize:'9px', color:t.color, border:'1px solid '+t.color+'44', background:'var(--fleet-map-legend)', borderRadius:'4px', padding:'4px 7px', fontWeight:700 } }, t.code);
      })
    )
  );
}

/* eslint-disable no-unused-vars */
function PositionBoard(props) {
  var vessels = props.vessels || [];
  var myVessels = props.myVessels || [];
  var onVessel = props.onVessel;
  return React.createElement('div', { style:{ height:'100%', overflowY:'auto', padding:'14px', background:'linear-gradient(180deg,rgba(0,212,255,.04),transparent 180px)' } },
    React.createElement('div', { style:{ display:'grid', gridTemplateColumns:'repeat(auto-fill,minmax(260px,1fr))', gap:'10px' } },
      vessels.map(function(v) {
        var isMine = hasMyVessel(myVessels, v);
        return React.createElement('button', { key:v.id, onClick:function(){onVessel && onVessel(v);}, style:{ textAlign:'left', background:'var(--s1)', border:'1px solid '+(isMine?'var(--accent)':'var(--b1)'), borderRadius:'var(--radius)', padding:'12px', color:'var(--text)', cursor:'pointer' } },
          React.createElement('div', { style:{ display:'flex', justifyContent:'space-between', gap:'8px', alignItems:'flex-start', marginBottom:'8px' } },
            React.createElement('div', null,
              React.createElement('div', { style:{ fontFamily:'var(--syne)', fontSize:'12px', fontWeight:700 } }, v.name),
              React.createElement('div', { style:{ fontSize:'9px', color:'var(--t3)', marginTop:'2px' } }, 'IMO '+v.imo+(v.mmsi?' · MMSI '+v.mmsi:'' ))
            ),
            tradeBadge(v)
          ),
          React.createElement('div', { style:{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:'7px', marginBottom:'8px' } },
            [['LAT', Number(v.lat || 0).toFixed(3)], ['LON', Number(v.lon || 0).toFixed(3)], ['STATUS', SL[v.status] || v.status], ['SPEED', v.status==='sea' ? v.speed+' kn' : '—']].map(function(item) {
              return React.createElement('div', { key:item[0], style:{ background:'var(--s2)', border:'1px solid var(--b1)', borderRadius:'5px', padding:'7px 8px' } },
                React.createElement('div', { style:{ fontSize:'8px', color:'var(--t3)', marginBottom:'2px' } }, item[0]),
                React.createElement('div', { style:{ fontSize:'11px', fontWeight:600 } }, item[1])
              );
            })
          ),
          React.createElement('div', { style:{ fontSize:'9px', color:'var(--t2)' } }, v.updated_by ? 'Noon report updated '+v.updated_by : 'Noon report / stored position')
        );
      })
    )
  );
}
/* eslint-enable no-unused-vars */

// ── MAIN COMPONENT ────────────────────────────────────────────────────────────
export default function FleetOverview({ onNavigate, onOpenSchedule }) {
  var s1 = useState(function() { return normalizeFleetVessels(KLINE_VESSELS); }); var vessels = s1[0]; var setVessels = s1[1];
  var s2 = useState('fleet'); var activeTab = s2[0]; var setActiveTab = s2[1];
  var s3 = useState('all'); var filter = s3[0]; var setFilter = s3[1];
  var s4 = useState(false); var mapMode = s4[0]; var setMapMode = s4[1];
  var s5 = useState([]); var myVessels = s5[0]; var setMyVessels = s5[1];
  var s7 = useState(false); var showAdd = s7[0]; var setShowAdd = s7[1];
  var s8 = useState(null); var deleteConfirm = s8[0]; var setDeleteConfirm = s8[1];
  var s9 = useState(null); var actionVessel = s9[0]; var setActionVessel = s9[1];
  var s10 = useState(''); var noonStatus = s10[0]; var setNoonStatus = s10[1];
  var s11 = useState(false); var mapMyOnly = s11[0]; var setMapMyOnly = s11[1];
  var mapRef = useRef(null); var leafletRef = useRef(null); var markersRef = useRef([]);

  const refreshFleetVessels = useCallback(function() {
    return listVessels().then(function(data) {
      if (data && data.length) {
        setVessels(function(current) {
          var merged = current.slice();
          data.filter(function(remoteVessel) {
            return KLINE_PDF_VESSEL_NAMES.includes(formatVesselName(remoteVessel.name).toUpperCase());
          }).forEach(function(remoteVessel) {
            mergeRemoteFleetVessel(merged, remoteVessel);
          });
          return normalizeFleetVessels(merged);
        });
      }
    });
  }, [setVessels]);

  useEffect(function() {
    refreshFleetVessels().catch(function() {});
  }, [refreshFleetVessels]);

  useEffect(function() {
    function handleFleetVesselsUpdated() {
      refreshFleetVessels().catch(function() {});
    }
    window.addEventListener('fleetVesselsUpdated', handleFleetVesselsUpdated);
    return function() {
      window.removeEventListener('fleetVesselsUpdated', handleFleetVesselsUpdated);
    };
  }, [refreshFleetVessels]);

  useEffect(function() {
    listMyVesselsFromApi().then(function(data) {
      setVessels(function(current) {
        var merged = current.slice();
        (data || []).forEach(function(remoteVessel) {
          mergeRemoteFleetVessel(merged, remoteVessel);
        });
        return normalizeFleetVessels(merged);
      });
      setMyVessels(uniqueVesselIds((data || []).map(function(vessel) { return vessel.id; })));
    }).catch(function() {});
  }, [setVessels, setMyVessels]);

  useEffect(function() {
    var validIds = validMyVesselIds(myVessels, vessels);
    if (!sameVesselIds(myVessels, validIds)) {
      setMyVessels(validIds);
    }
  }, [myVessels, vessels, setMyVessels]);

  useEffect(function() {
    if (true || !mapMode || activeTab !== 'fleet') return;
    var L = window.L;
    if (!L || !mapRef.current) return;
    if (!leafletRef.current) {
      leafletRef.current = L.map(mapRef.current, { center:[30,0], zoom:3, zoomControl:true, attributionControl:false });
      L.tileLayer('https://{s}.basemaps.cartocdn.com/dark_all/{z}/{x}/{y}{r}.png', { maxZoom:18, subdomains:'abcd' }).addTo(leafletRef.current);
    }
    markersRef.current.forEach(function(m) { m.remove(); });
    markersRef.current = [];
    vessels.forEach(function(v) {
      var color = SC[v.status] || '#fff';
      var html = '<div style="width:20px;height:20px;background:'+color+';border-radius:50%;border:2px solid rgba(255,255,255,.3);box-shadow:0 0 6px '+color+';display:flex;align-items:center;justify-content:center;font-size:7px;color:#000;font-weight:bold">'+(v.propulsion==='LNG'?'L':'K')+'</div>';
      var icon = L.divIcon({ html:html, className:'', iconAnchor:[10,10] });
      var marker = L.marker([v.lat||0, v.lon||0], { icon:icon }).addTo(leafletRef.current);
      marker.bindPopup('<div style="font-family:monospace;min-width:170px"><b style="color:#e8f4ff;font-size:12px">'+v.name+'</b>'+(v.propulsion==='LNG'?' <span style="color:#00e896;font-size:9px">[LNG]</span>':'')+'<br/><span style="color:'+color+'">'+v.route+'</span><br/>Speed: '+v.speed+' kn · Util: '+v.cargo_util+'%<br/>ETA: '+v.eta+'</div>');
      markersRef.current.push(marker);
    });
  }, [vessels, mapMode, activeTab]);


  async function addVessel(vessel) {
    try {
      var saved = await createVesselRecord(vessel);
      setVessels(function(prev) {
        var merged = prev.slice();
        mergeRemoteFleetVessel(merged, saved);
        return normalizeFleetVessels(merged);
      });
    } catch(error) {
      console.warn('Vessel save failed.', error.message);
    }
  }

  function deleteVessel(id) {
    if (!isDatabaseVesselId(id)) {
      setNoonStatus('Only saved fleet records can be deleted. PDF schedule vessels stay available.');
      setDeleteConfirm(null);
      return;
    }
    setVessels(function(prev) { return prev.filter(function(v){return v.id!==id;}); });
    setMyVessels(function(prev) { return prev.filter(function(x){return vesselIdKey(x)!==vesselIdKey(id);}); });
    deleteVesselRecord(id).catch(function(error) {
      console.warn('Vessel delete failed.', error.message);
      setNoonStatus('Vessel delete failed.');
    });
    setNoonStatus('Vessel deleted.');
    setDeleteConfirm(null);
  }

  async function toggleMyVessel(vesselOrId) {
    var localVessel = typeof vesselOrId === 'object'
      ? vesselOrId
      : vessels.find(function(vessel) { return vesselIdKey(vessel.id) === vesselIdKey(vesselOrId); });
    if (!localVessel) return;

    if (hasMyVessel(myVessels, localVessel)) {
      var removeKeys = [vesselIdKey(localVessel.id), vesselSelectionKey(localVessel)].filter(Boolean);
      var remainingIds = myVessels.filter(function(x){return !removeKeys.includes(vesselIdKey(x));});
      setMyVessels(remainingIds);
      try {
        await saveMyVesselsToApi(persistedMyVesselIds(remainingIds));
        setNoonStatus('My Vessel removed.');
        refreshFleetVessels().catch(function() {});
      } catch(error) {
        console.warn('My vessel save failed.', error.message);
        setNoonStatus('My Vessel remove failed.');
      }
      return;
    }

    var optimisticKey = vesselSelectionKey(localVessel);
    var optimisticIds = uniqueVesselIds(myVessels.concat([optimisticKey]));
    setMyVessels(optimisticIds);
    var selectedId = localVessel.id;
    if (!isDatabaseVesselId(selectedId)) {

      try {
        var saved = normalizeFleetVessels([await createVesselRecord(localVessel)])[0];
        selectedId = saved.id;
        setVessels(function(prev) {
          return prev.map(function(vessel) {
            return sameFleetVessel(vessel, localVessel) ? Object.assign({}, vessel, saved) : vessel;
          });
        });
      } catch(error) {
        try {
          var remote = await listVessels();
          var existing = remote.find(function(vessel) { return sameFleetVessel(vessel, localVessel); });
          if (!existing) throw error;
          var normalized = normalizeFleetVessels([existing])[0];
          selectedId = normalized.id;
          setVessels(function(prev) {
            return prev.map(function(vessel) {
              return sameFleetVessel(vessel, localVessel) ? Object.assign({}, vessel, normalized) : vessel;
            });
          });
        } catch {
          console.warn('My vessel save failed.', error.message);
          setNoonStatus('My Vessel was selected locally, but shared save failed.');
          return;
        }
      }
    }

    var nextIds = uniqueVesselIds(optimisticIds.filter(function(id) { return vesselIdKey(id) !== optimisticKey; }).concat([selectedId]));
    try {
      setMyVessels(nextIds);
      await saveMyVesselsToApi(persistedMyVesselIds(nextIds));
      setMyVessels(nextIds);
      setNoonStatus('My Vessel saved.');
      refreshFleetVessels().catch(function() {});
    } catch(error) {
      console.warn('My vessel save failed.', error.message);
      setNoonStatus('My Vessel was selected locally, but shared save failed.');
    }
  }

  function openScheduleFromFleet(vessel) {
    if (onOpenSchedule) onOpenSchedule(vessel);
    else if (onNavigate) onNavigate('rotation');
  }

  function refreshNoonPositions() {
    setNoonStatus('Refreshing noon report positions...');
    listVessels().then(function(remote) {
      if (!remote.length) {
        setNoonStatus('No noon report positions found.');
        return;
      }
      setVessels(function(current) {
        var merged = current.slice();
        remote.forEach(function(remoteVessel) {
          mergeRemoteFleetVessel(merged, remoteVessel);
        });
        return normalizeFleetVessels(merged);
      });
      setNoonStatus('Noon report positions refreshed.');
    }).catch(function() {
      setNoonStatus('Could not refresh noon report positions.');
    });
  }

  var filtered = filter==='all' ? vessels : vessels.filter(function(v){return v.status===filter;});
  var myVesselList = vessels.filter(function(v){return hasMyVessel(myVessels, v);});
  var dashboardVessels = activeTab === 'my' ? myVesselList : filtered;
  var mapVessels = mapMyOnly ? myVesselList : filtered;

  return React.createElement('div', { style:{ height:'100%', display:'flex', flexDirection:'column', overflow:'hidden' } },

    showAdd && React.createElement(AddVesselModal, { onAdd:addVessel, onClose:function(){setShowAdd(false);} }),

    deleteConfirm && React.createElement('div', { onClick:function(e){if(e.target===e.currentTarget)setDeleteConfirm(null);}, style:{ position:'fixed', inset:0, background:'rgba(0,0,0,.7)', zIndex:999, display:'flex', alignItems:'center', justifyContent:'center', backdropFilter:'blur(6px)' } },
      React.createElement('div', { style:{ background:'var(--s1)', border:'1px solid var(--red)', borderRadius:'10px', padding:'24px', width:'340px', textAlign:'center' } },
        React.createElement('div', { style:{ fontSize:'24px', marginBottom:'10px' } }, '🗑'),
        React.createElement('div', { style:{ fontFamily:'var(--syne)', fontSize:'14px', fontWeight:700, marginBottom:'6px' } }, 'Delete Vessel?'),
        React.createElement('div', { style:{ fontSize:'11px', color:'var(--t2)', marginBottom:'20px' } }, 'Remove '+deleteConfirm.name+' from the fleet? This cannot be undone.'),
        React.createElement('div', { style:{ display:'flex', gap:'8px', justifyContent:'center' } },
          React.createElement('button', { onClick:function(){setDeleteConfirm(null);}, style:{ background:'none', border:'1px solid var(--b1)', color:'var(--t2)', fontSize:'10px', padding:'8px 16px', borderRadius:'6px', cursor:'pointer' } }, 'Cancel'),
          React.createElement('button', { onClick:function(){deleteVessel(deleteConfirm.id);}, style:{ background:'rgba(255,69,96,.15)', border:'1px solid var(--red)', color:'var(--red)', fontSize:'10px', fontWeight:700, padding:'8px 16px', borderRadius:'6px', cursor:'pointer' } }, 'Delete')
        )
      )
    ),

    false && actionVessel && React.createElement('div', { onClick:function(e){if(e.target===e.currentTarget)setActionVessel(null);}, style:{ position:'fixed', inset:0, background:'rgba(0,0,0,.7)', zIndex:999, display:'flex', alignItems:'center', justifyContent:'center', backdropFilter:'blur(6px)' } },
      React.createElement('div', { style:{ background:'var(--s1)', border:'1px solid var(--b2)', borderRadius:'10px', padding:'22px', width:'360px' } },
        React.createElement('div', { style:{ display:'flex', alignItems:'center', gap:'7px', marginBottom:'4px' } },
          React.createElement('div', { style:{ fontFamily:'var(--syne)', fontSize:'14px', fontWeight:700 } }, actionVessel.name),
          voyageBadge(actionVessel)
        ),
        React.createElement('div', { style:{ display:'flex', alignItems:'center', gap:'6px', marginBottom:'18px', flexWrap:'wrap' } },
          React.createElement('span', { style:{ fontSize:'10px', color:'var(--t2)' } }, 'IMO '+actionVessel.imo+' - '+(actionVessel.route||'No route set')),
          tradeBadge(actionVessel)
        ),
        React.createElement('div', { style:{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:'8px', marginBottom:'14px' } },
          React.createElement('button', { onClick:function(){openScheduleFromFleet(actionVessel);setActionVessel(null);}, style:{ background:'var(--green)', border:'none', color:'#000', fontFamily:'var(--syne)', fontSize:'11px', fontWeight:700, padding:'10px', borderRadius:'6px', cursor:'pointer' } }, 'VOYAGE PLAN'),
          React.createElement('button', { onClick:function(){if(onOpenSchedule)onOpenSchedule(actionVessel);else if(onNavigate)onNavigate('rotation');setActionVessel(null);}, style:{ background:'var(--accent)', border:'none', color:'var(--on-accent)', fontFamily:'var(--syne)', fontSize:'11px', fontWeight:700, padding:'10px', borderRadius:'6px', cursor:'pointer' } }, 'SCHEDULE')
        ),
        React.createElement('button', { onClick:function(){setActionVessel(null);}, style:{ width:'100%', background:'none', border:'1px solid var(--b1)', color:'var(--t2)', fontSize:'10px', padding:'8px', borderRadius:'6px', cursor:'pointer' } }, 'Close')
      )
    ),

    React.createElement('div', { style:{ padding:'10px 16px', display:'flex', justifyContent:'space-between', alignItems:'center', flexShrink:0, borderBottom:'1px solid var(--b1)', flexWrap:'wrap', gap:'8px' } },
      React.createElement('div', { style:{ display:'flex', gap:'2px', background:'var(--s2)', border:'1px solid var(--b1)', borderRadius:'var(--radius-sm)' } },
        [['fleet','Fleet ('+vessels.length+')'],['my','My Vessels ('+myVesselList.length+')']].map(function(item) {
          return React.createElement('button', { key:item[0], onClick:function(){setActiveTab(item[0]); if(item[0]==='my')setMapMyOnly(true);}, style:{ background:activeTab===item[0]?'var(--accent)':'none', border:'none', color:activeTab===item[0]?'#000':'var(--t2)', fontSize:'10px', padding:'6px 14px', borderRadius:'var(--radius-sm)', cursor:'pointer', fontWeight:activeTab===item[0]?600:400, whiteSpace:'nowrap' } }, item[1]);
        })
      ),
      React.createElement('div', { style:{ display:'flex', gap:'8px', alignItems:'center', flexWrap:'wrap' } },
        activeTab==='fleet' && !mapMode && React.createElement('div', { style:{ display:'flex', gap:'4px' } },
          ['all','sea','port','loading','discharge'].map(function(f) {
            return React.createElement('button', { key:f, onClick:function(){setFilter(f);}, style:{ background:filter===f?'var(--accent)':'var(--s2)', border:'1px solid var(--b1)', color:filter===f?'#000':'var(--t2)', fontSize:'9px', padding:'4px 8px', borderRadius:'var(--radius-sm)', cursor:'pointer' } }, f.toUpperCase());
          })
        ),
        activeTab==='fleet' && React.createElement('div', { style:{ display:'flex', background:'var(--s2)', border:'1px solid var(--b1)', borderRadius:'var(--radius-sm)' } },
          React.createElement('button', { onClick:function(){setMapMode(true);}, style:{ background:mapMode?'var(--accent)':'none', border:'none', color:mapMode?'#000':'var(--t2)', fontSize:'9px', padding:'5px 10px', borderRadius:'var(--radius-sm)', cursor:'pointer' } }, 'MAP'),
          React.createElement('button', { onClick:function(){setMapMode(false);}, style:{ background:!mapMode?'var(--accent)':'none', border:'none', color:!mapMode?'#000':'var(--t2)', fontSize:'9px', padding:'5px 10px', borderRadius:'var(--radius-sm)', cursor:'pointer' } }, 'CARDS')
        ),
        mapMode && React.createElement('label', { style:{ display:'flex', alignItems:'center', gap:'5px', fontSize:'9px', color:'var(--t2)', background:'var(--s2)', border:'1px solid var(--b1)', borderRadius:'var(--radius-sm)', padding:'5px 8px' } },
          React.createElement('input', { type:'checkbox', checked:mapMyOnly, onChange:function(e){setMapMyOnly(e.target.checked);} }),
          'My vessels'
        ),
        mapMode && React.createElement('button', { onClick:refreshNoonPositions, style:{ background:'var(--s2)', border:'1px solid var(--b1)', color:'var(--accent)', fontSize:'9px', padding:'5px 10px', borderRadius:'var(--radius-sm)', cursor:'pointer' } }, 'REFRESH NOON POSITIONS'),
        noonStatus && React.createElement('span', { style:{ fontSize:'9px', color:noonStatus.includes('saved') || noonStatus.includes('removed') || noonStatus.includes('deleted') || noonStatus.includes('refreshed') ? 'var(--green)' : 'var(--yellow)' } }, noonStatus),
        React.createElement('button', { onClick:function(){setShowAdd(true);}, style:{ background:'var(--accent)', border:'none', color:'var(--on-accent)', fontSize:'10px', fontWeight:700, padding:'6px 14px', borderRadius:'var(--radius-sm)', cursor:'pointer', whiteSpace:'nowrap' } }, '+ Add Vessel')
      )
    ),

    false && activeTab === 'my' ? (
      React.createElement('div', { style:{ flex:1, overflowY:'auto', padding:'16px' } },
        React.createElement('div', { style:{ fontFamily:'var(--syne)', fontSize:'15px', fontWeight:700, marginBottom:'4px' } }, 'My Vessels'),
        React.createElement('div', { style:{ fontSize:'10px', color:'var(--t2)', marginBottom:'16px' } }, 'Vessels you are PIC for. Click + My Vessel on any card to nominate.'),
        myVesselList.length === 0 ? (
          React.createElement('div', { style:{ textAlign:'center', padding:'40px', color:'var(--t3)' } },
            React.createElement('div', { style:{ fontSize:'28px', marginBottom:'10px' } }, '🚢'),
            React.createElement('div', { style:{ fontFamily:'var(--syne)', fontSize:'13px', color:'var(--t2)', marginBottom:'6px' } }, 'No vessels nominated yet'),
            React.createElement('div', { style:{ fontSize:'11px', marginBottom:'16px' } }, 'Go to Fleet tab and click + My Vessel on any card'),
            React.createElement('button', { onClick:function(){setActiveTab('fleet');}, style:{ background:'var(--accent)', border:'none', color:'var(--on-accent)', fontSize:'11px', padding:'8px 16px', borderRadius:'var(--radius-sm)', fontWeight:600, cursor:'pointer' } }, 'Go to Fleet')
          )
        ) : (
          React.createElement('div', { style:{ display:'grid', gridTemplateColumns:'repeat(auto-fill,minmax(280px,1fr))', gap:'12px' } },
            myVesselList.map(function(v) {
              return React.createElement('div', { key:v.id, style:{ background:'var(--s1)', border:'1px solid var(--accent)', borderRadius:'var(--radius)', padding:'16px' } },
                React.createElement('div', { style:{ display:'flex', justifyContent:'space-between', alignItems:'flex-start', marginBottom:'8px' } },
                  React.createElement('div', null,
                    React.createElement('div', { style:{ fontFamily:'var(--syne)', fontWeight:700, fontSize:'13px', marginBottom:'3px' } }, v.name),
                    React.createElement('div', { style:{ display:'flex', gap:'5px', alignItems:'center', flexWrap:'wrap' } },
                      React.createElement('span', { style:{ fontSize:'9px', color:'var(--t3)' } }, v.imo+' · '+v.type),
                      voyageBadge(v),
                      tradeBadge(v),
                      v.propulsion==='LNG' && React.createElement(LngBadge)
                    )
                  ),
                  React.createElement('button', { onClick:function(){toggleMyVessel(v);}, style:{ background:'rgba(255,69,96,.1)', border:'1px solid var(--red)', color:'var(--red)', fontSize:'8px', padding:'2px 6px', borderRadius:'3px', cursor:'pointer' } }, 'Remove')
                ),
                React.createElement('div', { style:{ display:'grid', gridTemplateColumns:'1fr 1fr 1fr', gap:'6px', marginBottom:'10px' } },
                  [['Status',(SL[v.status]||v.status),SC[v.status]||'var(--text)'],['Speed',v.status==='sea'?v.speed+' kn':'Berth','var(--text)'],['Util',v.cargo_util+'%',fc(v.cargo_util)],['Kxx',kxxText(v.lane_meters),'var(--accent)'],['Voyage',v.voyage_number || '—','var(--yellow)'],['ETA',v.eta,'var(--text)'],['Route',v.route,'var(--t2)']].map(function(item) {
                    return React.createElement('div', { key:item[0], style:{ background:'var(--s2)', borderRadius:'5px', padding:'7px 8px' } },
                      React.createElement('div', { style:{ fontSize:'8px', color:'var(--t3)', marginBottom:'2px' } }, item[0]),
                      React.createElement('div', { style:{ fontSize:'11px', fontWeight:500, color:item[2] } }, item[1])
                    );
                  })
                ),
                React.createElement('div', { style:{ height:'4px', background:'var(--b1)', borderRadius:'2px', overflow:'hidden', marginBottom:'12px' } },
                  React.createElement('div', { style:{ height:'100%', width:v.cargo_util+'%', background:fc(v.cargo_util), borderRadius:'2px' } })
                ),
                React.createElement('button', { onClick:function(){openScheduleFromFleet(v);}, style:{ width:'100%', background:'var(--accent)', border:'1px solid var(--accent)', color:'#fff', fontFamily:'var(--sans)', fontSize:'14px', fontWeight:600, padding:'10px 12px', borderRadius:'10px', cursor:'pointer' } }, 'Voyage Plan')
              );
            })
          )
        )
      )
    ) : (
      React.createElement('div', { style:{ flex:1, overflow:'hidden' } },
        mapMode ? (
          React.createElement(LeafletWorldMap, { vessels:mapVessels, myVessels:myVessels, onVessel:openScheduleFromFleet })
        ) : (
          React.createElement('div', { style:{ height:'100%', overflowY:'auto', padding:'14px', display:'grid', gridTemplateColumns:'repeat(auto-fill,minmax(270px,1fr))', gap:'10px', alignContent:'start' } },
            dashboardVessels.map(function(v) {
              return React.createElement(FleetVesselCard, {
                key:v.id,
                vessel:v,
                isMyVessel:hasMyVessel(myVessels, v),
                onOpen:openScheduleFromFleet,
                onToggleMine:toggleMyVessel,
                onDelete:setDeleteConfirm,
              });
            })
          )
        )
      )
    )
  );
}


